<template>
    <div class="page-layout blank contacts-manage pl-1">
         <div class="p-5 position-content-main">
              <div class="justify-content-between d-flex header-bottom">
                   <div class="breadcrumbnewtheme pb-3">
                   <div class="pre gap-0p5 fw-500">
                        Ticket
                   </div>
                   <span style="color:#b2bec3">/</span>
                   <div class="pre gap-0p5 fw-500">
                        List View
                   </div>
                   <span style="color:#b2bec3">/</span>
                   <span class="curr gap-0p5 fw-500">
                        Edit #{{editTicketDetails.ticket_number || '-'}}
                   </span>
                   </div>
                   <div @click="goTOBack" class="pointer">
                   <img src="/static/images/arrow-left-circle-line.svg" alt="" width="22px">
                   <span class="text-black fw-500 pl-1">Back</span>
                   </div>
              </div>
              <!-- <div class="d-flex align-items-center justify-content-between"> 
                   <div class="breadcrumbactive">
                        <div>
                             <span class="pointer" @click="goToListView">Tickets</span>
                             <div> {{this.$route.path.startsWith('/ticketdetails/view/') ? 'View' : 'Edit'}} #{{editTicketDetails.ticket_number || '-'}}</div>
                        </div>
                   </div>
                   <button class="btn btn-secondary" v-if="(can_edit || can_close_ticket) && $route.path.startsWith('/ticketdetails/view/')" @click="goToEditTicket">{{ editTicketDetails.status == 'Fixed' && template_type == 'multi_part' ? 'Close The Ticket' : 'Edit' }}</button>
              </div> -->
              <div v-if="ajaxCallinprogress" class="bg-white d-flex align-items-center justify-content-center min-height-500px">
                   <img src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader" />
              </div>
              <div v-else class="general-section pt-2  mt-0">
                   <div v-if="isUploadingInProgress" class="checkoutLoader">
                        <div class="LoaderPlacement">
                             <div class="digi-table-loader">
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                             </div>
                        </div>
                   </div>
                   <div class=" mb-5">
                        <div class="mb-5" style="overflow: auto;max-height: auto;background:#f0ddb7 ">
                             <div class="general-section general-box py-4 mt-3 px-0 px-lg-4">
                                 <span class="list-text fs-15 fw-600 text-black">1. General Details</span>
                                  <div class="row mt-3">
                                       <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                                            <div class="w-100">
                                                 <div class="d-flex flex-column pt-2" :class="{'justify-content-start': template_type == 'multi_part', 'justify-content-between': template_type == 'default'}">
                                                      <label class="inputLabel fs-14 fw-500 text-black mb-1">Subject <span class="text-danger"> *</span></label>
                                                      <input v-validate="'required'" name="subject" 
                                                           class="inputFieldNew overflowing-text mt-3" :class="this.$route.path.startsWith('/ticketdetails/view/') ? 'field_disabled' : ''"
                                                           style="padding-right: 30px !important;" type="text" :maxlength="subjectlength" 
                                                           v-model="subject" placeholder="Enter Ticket Subject"
                                                           :disabled="this.$route.path.startsWith('/ticketdetails/view/') || (editTicketDetails.ticket_template.template_type == 'multi_part' && editTicketDetails.status == 'Fixed')" />
                                                 </div>
                                                 <span class="inputBorder"></span>
                                                 <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('subject')" style="display: inline !important">{{ errors.first("subject") }}</span>
                                                 <span class="pull-right text-right font-600 fs-12 pt-1">{{ subjectlength - subject.length}}/{{subjectlength}}</span>
                                            </div>
                                       </div>
                                       <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                                            <div class="form-group contactGroup pt-0 h-100">
                                                 <div class="d-flex flex-column  pt-2" :class="{'justify-content-start': template_type == 'multi_part', 'justify-content-between': template_type == 'default'}">
                                                      <span class="fs-14 fw-500 text-black">
                                                           Ticket Template<span class="text-danger"> *</span>
                                                      </span>
                                                      <div class="d-flex align-items-center" :title="ticketType.name">
                                                           <input 
                                                                v-validate="'required'" name="ticketType" 
                                                                class="inputFieldNew text-capitalize overflowing-text field_disabled mt-4" 
                                                                style="padding-right: 30px !important;" type="text" label="name" disabled v-model="ticketType.name" 
                                                                placeholder="Enter Ticket Template" />
                                                           <span class="inputBorder"></span>
                                                      </div>
                                                 </div>
                                            </div>
                                       </div>
                                       <div class="col-lg-6 col-md-6 col-sm-12" v-if="template_type != 'multi_part'">
                                            <div class="form-group contactGroup" style="margin-top: 0px;z-index:1 !important;">
                                                 <div class="vendor_type">
                                                      <label class="text-black mr-2 fs-14 fw-500" >Assigned to
                                                           <span class="text-danger ml-0">*</span>
                                                           <span style="position:absolute;top:14px;left:auto; margin-left: -2px;">
                                                                <el-tooltip class="item pull-right" effect="dark" content="Employees" placement="top">
                                                                     <i class="ri-2x ri-information-line text-black fs-16"></i>
                                                                </el-tooltip>
                                                           </span>
                                                      </label>
                                                      <el-radio-group class="d-flex align-items-center mt-2 mob-issue-fix" v-model="assignedTo" :disabled="this.$route.path.startsWith('/ticketdetails/view/')">
                                                           <el-tooltip class="item pull-right" v-if="template_type == 'multi_part'" effect="dark" content="A Person cannot be assigned to Multi Part Templates" placement="top">
                                                                <el-radio :disabled="template_type == 'multi_part'" @input="assignedToChange()" label="person">
                                                                     Person
                                                                </el-radio>
                                                           </el-tooltip>
                                                           <el-radio v-else @input="assignedToChange()" label="person">
                                                                Person
                                                           </el-radio>
                                                           <el-tooltip class="item pull-right" effect="dark" content="Assigning Tickets To Teams Coming Soon" placement="top">
                                                           <el-radio disabled label="team">
                                                                Team
                                                           </el-radio>
                                                           </el-tooltip>
                                                           <el-radio label="unassigned">
                                                           Unassigned
                                                           </el-radio>
                                                      </el-radio-group>
                                                 </div>
                                                 <div v-if="assignedTo == 'unassigned'" :class="this.$route.path.startsWith('/ticketdetails/view/') ? 'field_disabled' : ''" class="inputFieldNew" style="padding: 12px 11px 8px 8px !important;border-radius: 8px !important;" >
                                                      Unassigned
                                                 </div>
                                                 <multiselect v-else label="name"
                                                      v-validate="'required'"
                                                      class="diginew-multiselect down-arrow custom-cred-fs mt-3"
                                                      :class="this.$route.path.startsWith('/ticketdetails/view/') ? 'field_disabled' : ''"
                                                      :disabled="this.$route.path.startsWith('/ticketdetails/view/')"
                                                      name="assigned" open-direction="top"
                                                      v-model="assignedCustomer" :options-limit="3000"
                                                      :max-height="200"
                                                      :options="assign_options"
                                                      :searchable="true"
                                                      :close-on-select="true"
                                                      @search-change="getAllAssignTo"
                                                      :show-labels="false"
                                                      :loading="assign_loading"
                                                 >
                                                      <template slot="placeholder">
                                                           <span class="diginewhelp-multiselect">Select Name</span>
                                                      </template>
                                                      <template slot="afterList">
                                                           <div v-observe-visibility="reachedEndOfAssigned" />
                                                      </template>
                                                      <template slot="noResult">
                                                      <div v-if="assign_options.length">
                                                           <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                           </div>
                                                      </div>
                                                      <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                                 </template>
                                                 </multiselect>
                                                 <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('assigned')">{{ errors.first("assigned") }}</span>
                                            </div>
                                       </div>
                                       <div class="col-lg-4 col-md-6 col-sm-12 mt-3" v-if="is_approvers_mandatory">
                                            <div class="form-group contactGroup pt-0">
                                                 <span class="fs-14 fw-500 text-black">
                                                      Approver<span class="text-danger"> *</span>
                                                 </span>
                                                 <div class="d-flex align-items-center mt-4">
                                                      <multiselect
                                                           v-model="approvers_data" id="ajax"
                                                           :disabled="$route.path.startsWith('/ticketdetails/view/') || !can_edit_approver"
                                                           class="diginew-multiselect overflow-text arrow-custom h-100px-ms filter-multiple custom-cred-fs"
                                                           :options="approvers_options"
                                                           data-vv-as="Approver" track-by="id"
                                                           :searchable="true"
                                                           :close-on-select="false"
                                                           name="approversData"
                                                           :show-labels="false"
                                                           :multiple="true"
                                                           :options-limit="3000"
                                                           :max-height="200"
                                                           v-validate="is_approvers_mandatory ? 'required' : ''"
                                                           :clear-on-select="true"
                                                           label="name"
                                                           :internal-search="true"
                                                           :show-no-results="true"
                                                           :allow-empty="true"
                                                           :hide-selected="false"
                                                           :blockKeys="['Delete']"
                                                           @remove="removeApprovers"
                                                      >
                                                           <template slot="tag" slot-scope="{ option }">
                                                           <span class="custom__tag1">
                                                                <span class="filterSelectedName1">{{ option.name }}</span>
                                                                <span class="custom__remove pointer">
                                                                     <i class="icon icon-close fs-16 text-white" style="display:none"></i>
                                                                </span>
                                                                <span class="custom__remove pointer" v-if="$route.path.startsWith('/ticketdetails/edit/') && approvers_removable" @click="removeApprovers(option)">
                                                                     <i class="icon icon-close fs-16 text-white"></i>
                                                                </span>
                                                           </span>
                                                           </template>
                                                           <template slot="placeholder">
                                                           <span class="diginewhelp-multiselect">Select Approvers</span>
                                                           </template>
                                                           <template slot="noOptions">
                                                                <div class="text-secondary text-center font-weight-bold">Approvers Are Not Found</div>
                                                           </template>
                                                           <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                                           </template>
                                                      </multiselect>
                                                 </div>
                                                 <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('approversData')">{{ errors.first("approversData") }}</span>
                                            </div>
                                       </div>
                                       <div class="col-lg-12 col-md-12 col-sm-12">
                                            <div class="form-group contactGroup" style="margin-top: 0px;z-index:1 !important;height:75%">
                                                 <label class="text-black fw-500 fs-14 mr-2" >Description</label>
                                                 <!-- <textarea name="description" rows="5" placeholder="Enter Description" class="w-100 mt-1 fw-600" :disabled="this.$route.path.startsWith('/ticketdetails/view/') || (editTicketDetails.ticket_template.template_type == 'multi_part' && editTicketDetails.status == 'Fixed')" style="height:101%;border: 1px solid #676767;border-radius:5px;padding: 5px 10px;resize: none" maxlength="1000" v-model="description"></textarea> -->

                                                 <!-- :disabled="this.$route.path.startsWith('/ticketdetails/view/') || (editTicketDetails.ticket_template.template_type == 'multi_part' && editTicketDetails.status == 'Fixed')" -->
                                                 <vue-editor name="description" class="desc-editor my-2" :placeholder="description =='' ? 'Enter Description' :''"
                                                      v-model="description" :class="this.$route.path.startsWith('/ticketdetails/view/') || (editTicketDetails.ticket_template.template_type == 'multi_part' && editTicketDetails.status == 'Fixed') ? 'ql_disabled' : ''">
                                                 </vue-editor>
                                                 <span class="pull-right text-right font-600 fs-12">{{ 1000 - description.length}}/{{1000}}</span>
                                            </div>
                                       </div>
                                  </div>
                             </div>
                             <div class="general-section general-box py-4 pb-6 mt-5 px-0 px-lg-4" v-if="generalActive && template_type == 'default'">
                                  <span class="list-text fw-15 fw-600 text-black">2. Ticket Details</span>
                                  <div class="row" v-if="editTicketTemplate.length > 0">
                                       <div class="col-lg-12 col-md-12 col-sm-12 mt-5" v-for="(td, i) in editTicketTemplate" :key='i'>
                                            <div class="d-flex flex-column justify-content-between h-100" > 
                                                 <div class="fw-600 pt-2 pb-2 fs-14 text-black d-inline-block w-100 overflowing-text" :title="td.name">{{td.name.split('').length > 1 ?  td.name[0].toUpperCase() +''+ td.name.slice(1,) : td.name[0].toUpperCase()}}<span class="text-danger" v-if="td.required == true"> *</span></div>
                                                 <div>
                                                      <div v-if="ticketType.name == 'Digicollect Product Template'">
                                                           <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                                                v-model="td.answer" track-by="_id"
                                                                class="diginew-multiselect arrow-custom mt-3 down-arrow"
                                                                :loading="apicall_loading"
                                                                :options="scm_products_options"
                                                                :searchable="true"
                                                                :close-on-select="true"
                                                                :name="'apidrop_down'+ i"
                                                                :show-labels="false"
                                                                @search-change="searchTemplateApiDD"
                                                                @open="getTemplateApiDD"
                                                                @close="insertProductTag(td.answer)"
                                                                :multiple="false"
                                                                :options-limit="3000"
                                                                :max-height="200"
                                                                v-validate="td.required ? 'required' : ''"
                                                                :clear-on-select="false"
                                                                label="name"
                                                                :internal-search="true"
                                                                :show-no-results="true"
                                                                :hide-selected="false"
                                                                >
                                                                <template slot="placeholder">
                                                                     <span class="diginewhelp-multiselect">Select Product</span>
                                                                </template>
                                                                <template slot="afterList">
                                                                     <div v-observe-visibility="reachedEndOfApiDD" />
                                                                </template>
                                                                <template slot="noResult">
                                                                     <div v-if="scm_products_options.length">
                                                                          <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                               <div></div>
                                                                               <div></div>
                                                                               <div></div>
                                                                               <div></div>
                                                                          </div>
                                                                     </div>
                                                                     <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                                                </template>
                                                           </multiselect>
                                                      </div>
                                                      <div v-else>
                                                           <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                                                v-model="td.answer" track-by="_id"
                                                                class="diginew-multiselect arrow-custom mt-3 down-arrow"
                                                                :loading="apicall_loading"
                                                                :options="scm_products_options"
                                                                :searchable="true"
                                                                :close-on-select="true"
                                                                :name="'apidrop_down'+ i"
                                                                :show-labels="false"
                                                                @search-change="searchApiDD"
                                                                @open="getApiDD"
                                                                @close="insertProductTag(td.answer)"
                                                                :multiple="false"
                                                                :options-limit="3000"
                                                                :max-height="200"
                                                                v-validate="td.required ? 'required' : ''"
                                                                :clear-on-select="false"
                                                                label="name"
                                                                :internal-search="true"
                                                                :show-no-results="true"
                                                                :hide-selected="false"
                                                                >
                                                                <template slot="placeholder">
                                                                     <span class="diginewhelp-multiselect">Select Product</span>
                                                                </template>
                                                                <template slot="afterList">
                                                                     <div v-observe-visibility="reachedEndOfApiDD" />
                                                                </template>
                                                                <template slot="noResult">
                                                                     <div v-if="scm_products_options.length">
                                                                          <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                               <div></div>
                                                                               <div></div>
                                                                               <div></div>
                                                                               <div></div>
                                                                          </div>
                                                                     </div>
                                                                     <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                                                </template>
                                                           </multiselect>
                                                      </div>
                                                      <!-- Short Answer -->
                                                      <input v-if="td.type == 'short_answer'"
                                                      class="border-bottom-custom inputFieldNew"
                                                      style="padding-right: 30px !important;"
                                                      type="text"
                                                      maxlength="100"
                                                      v-model="td.answer"
                                                      placeholder="Enter Short Answer"
                                                      :name="'short_answer'+ i"
                                                      v-validate="td.required ? 'required' : ''"
                                                      data-vv-as="Short Answer"
                                                      />
                                                      <!-- Radiobutton -->
                                                      <el-radio-group v-if="td.type == 'radio_button'" class="d-flex align-items-center mt-5 mob-issue-fix block-dis  w-100" v-model="td.answer" v-validate="td.required ? 'required' : ''" :name="'radio_button'+ i" data-vv-as="Radio Button">
                                                           <div class="row">
                                                                <el-radio class="col-xl-2 col-lg-2 col-md-4 col-sm-6 w-300px text-capitalize  d-flex word-wrap" :label="radio_options" v-for="(radio_options, ri) in td.possible_values" :key="ri">
                                                                     {{radio_options}}
                                                                </el-radio>
                                                           </div>
                                                      </el-radio-group>
                                                      <!-- Checkbox -->
                                                      <el-checkbox-group v-if="td.type == 'check_box'" class="refund-checkbox mt-4  w-100" v-validate="td.required ? 'required' : ''" :name="'check_box'+ i" data-vv-as="Check Box" v-model="td.answer">
                                                           <div class="row">
                                                                <el-checkbox class="col-xl-2 col-lg-2 col-md-4 col-sm-6 w-150 text-capitalize d-flex word-wrap" :label="check_options" v-for="(check_options, ci) in td.possible_values" :key="ci">
                                                                     {{check_options}}
                                                                </el-checkbox>
                                                           </div>
                                                      </el-checkbox-group>
                                                      <!-- Date -->
                                                      <date-picker v-if="td.type == 'date'"
                                                           class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor" placeholder="MM/DD/YYYY"
                                                           v-validate="td.required ? 'required' : ''"
                                                           :name="'date'+ i" onkeypress="return event.charCode >= 47 && event.charCode <= 57"
                                                           data-vv-as="Date" :editable="true"
                                                           value-type="format"
                                                           format="MM/DD/YYYY" type="date" lang="en" v-model="td.answer"
                                                           style="border:none !important">
                                                      </date-picker>
                                                      <!-- Time -->
                                                      <date-picker v-if="td.type == 'time'"
                                                           v-model="td.answer"
                                                           format="hh:mm A"
                                                           :name="'time'+ i"
                                                           data-vv-as="Time"
                                                           class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-clock-icon"
                                                           type="time"
                                                           placeholder="Enter the time"
                                                           lang="en" onkeypress="return event.charCode >= 48 && event.charCode <= 58"
                                                           value-type="format"
                                                           :clearable="false"
                                                           :editable="true"
                                                           @confirm="HandleTimeEvent($event, i, 'time')"
                                                           :minute-step="1"
                                                           confirm
                                                           confirm-text="APPLY"
                                                           v-validate="td.required ? 'required' : ''"
                                                      ></date-picker>
                                                      <!-- Date and time -->
                                                      <div class="d-flex align-items-center" v-if="td.type == 'date_time'">
                                                           <div class="row">
                                                                <date-picker v-if="td.type == 'date_time'"
                                                                class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor col-lg-6 col-md-6 col-sm-12" placeholder="MM/DD/YYYY"
                                                                v-validate="td.required ? 'required' : ''"
                                                                :name="'date_time'+ i"
                                                                data-vv-as="Date" onkeypress="return event.charCode >= 47 && event.charCode <= 57"
                                                                value-type="format" :editable="true"
                                                                format="MM/DD/YYYY" type="date" lang="en" v-model="td.date"
                                                                style="border:none !important">
                                                                </date-picker>
                                                                <date-picker v-if="td.type == 'date_time'"
                                                                v-model="td.time"
                                                                format="hh:mm A"
                                                                :name="'date_time'+ i"
                                                                data-vv-as="Time"
                                                                class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-disabled date-picker-clock-icon col-lg-6 col-md-6 col-sm-12"
                                                                type="time"
                                                                placeholder="Enter the time"
                                                                lang="en" onkeypress="return event.charCode >= 48 && event.charCode <= 58"
                                                                value-type="format"
                                                                @confirm="HandleTimeEvent($event, i, 'date_time')"
                                                                :clearable="false"
                                                                :editable="true"
                                                                :minute-step="1"
                                                                confirm
                                                                confirm-text="APPLY"
                                                                v-validate="td.required ? 'required' : ''"
                                                                ></date-picker>
                                                           </div>
                                                      </div>
                                                      <!-- Description -->
                                                      <textarea placeholder="Enter Long Answer"  maxlength="500" v-validate="td.required ? 'required' : ''" :name="'long_answer'+ i" data-vv-as="Long Answer" v-if="td.type == 'long_answer'" v-model="td.answer" class="desc-textarea mt-3"></textarea>
                                                      <!-- Dropdown -->
                                                      <multiselect
                                                           v-if="td.type == 'drop_down' && td.is_api_call_required == false"
                                                           v-validate="td.required ? 'required' : ''"
                                                           class="diginew-multiselect border-bottom-custom down-arrow mt-3"
                                                           :name="'drop_down'+ i" style="width: 250px !important"
                                                           data-vv-as="Drop Down"
                                                           v-model="td.answer"
                                                           :options="td.possible_values"
                                                           :searchable="true"
                                                           :close-on-select="true"
                                                           :show-labels="false"
                                                      >
                                                           <template slot="placeholder">
                                                                <span class="diginewhelp-multiselect">Select Dropdown</span>
                                                           </template>
                                                      </multiselect>
                                                      <!-- Tags -->
                                                      <vue-tags-input v-if="td.type == 'tag'" :name="'tags'+ i"
                                                           data-vv-as="Tags" v-model="td.entered_tag" v-validate="td.required && td.answer.length == 0 ? 'required' : ''" 
                                                           class="multi_part-sec border-bottom-custom inputFieldNew-tags create-edit-ticket-tags rel-x2 mt-3" :tags="td.answer" 
                                                           @tags-changed="tagsChangeData($event, i, 'by-field')" maxlength="40" id='to_email' :delete-on-backspace="false"
                                                           :placeholder="ticketType.name == 'Digicollect Product Template' || ticketType.name == 'Product Bug Template' ? 'Add Custom Tags' : $route.path.startsWith('/ticketdetails/view/') && td.answer.length == 0 ? 'No Data' : 'Enter Tags Here'" />
                                                      <!-- Location -->
                                                      <div v-if="td.type == 'location'">
                                                           <div class="digi-table-loader d-flex justify-content-center" v-if="location_loader" id="spinner" style="margin: 0 auto;position:absolute">
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                           </div>
                                                           <div class="form-group contactGroup pt-0">
                                                                <div class="d-flex align-items-center">
                                                                     <div class="form-group gMap" style="position:relative;width:100%;">
                                                                     <input class="inputFieldNew overflowing-text mt-0 border-bottom-custom" style="padding-right: 30px !important;" :name="'location' + i" disabled type="text" v-model="td.location_details.location_vmodel" placeholder="Enter Location" />
                                                                     <div class="d-flex">
                                                                          <i class="icon icon-map-marker color-blue" style="position: absolute;right: 5px;bottom: 9px;"></i>
                                                                     </div>
                                                                     </div>
                                                                     <div class="gps-logo pointer" :id="'DisableOnClick' + i" @click="getLocation(i)">
                                                                          <i class="icon-crosshairs-gps color-blue" ></i>
                                                                     </div>
                                                                </div>
                                                           </div>
                                                      </div>
                                                      <div v-if="td.statement">
                                                           <textarea v-model="td.reason" v-validate="td.required ? 'required' : ''" class="text-reason" 
                                                           :placeholder="$route.path.startsWith('/ticketdetails/view/') ? 'No Data' : 'Enter a reason'" 
                                                           :name="`reason${i}`" data-vv-as="Reason"></textarea>
                                                           <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has(`reason${i}`)">
                                                                {{errors.first(`reason${i}`)}}
                                                           </span>
                                                      </div>
                                                      <!-- Default Field Attachments -->
                                                      <div v-if="td.add_attachments" class="mt-3">
                                                           <span class="fw-500 fs-15px">Attachments</span>
                                                           <div class="row mt-4 justify-content-frsm">
                                                                <div class="col-lg-12 col-md-6 col-sm-12">
                                                                     <div class="mt-4" @drop="dropAttachmentDefaultFieldAttachment($event, i)" @dragover="dragOverAttachment($event)">
                                                                          <div class="img-upload pl-4 pr-sm-15 pt-3 pb-3 bg-white">
                                                                               <img width="30" src="/static/images/draganddrop.svg" class="" alt="Capture Image"/>
                                                                               <span class="pr-4 pl-4 hide-on-mob">Drag and Drop Files Here 1</span>
                                                                               <span class="pr-4 hide-on-mob" style="font-weight:600 !important;">OR</span>
                                                                                    <file-upload id="multiple" v-if="td.attachments.length < 5"
                                                                                         class="choose-file btn btn-new-primary "
                                                                                         type="file"
                                                                                         @input-file="uploadDefaultFieldAttachment($event, i)" accept=".pdf,.csv,.ods,.zip,.doc,.docx,.xls,image/*" ref="upload"
                                                                                         webkitdirectory mozdirectory
                                                                                         style="text-transform: none !important; padding:2px 18px 6px 18px !important;">
                                                                                         <i class="icon ri-upload-2-line text-white fs-15 pr-1"></i>
                                                                                         Click to Upload
                                                                                    </file-upload>
                                                                                    <label class="choose-file ml-2 btn-upload-disabled cursor-notallowed" v-else>
                                                                                         Browse Files
                                                                                    </label>
                                                                               <span class="pr-4 pl-4" style="font-weight:600 !important;">OR</span>
                                                                               <span class="pr-4 pointer">
                                                                                    <img width="30" @click="openCaptureImage" src="/static/images/camera-3-line.svg" alt="Capture Image" v-if="attachments.length < 10"/>
                                                                                    <img width="30" src="/static/images/camera-3-line.svg" class="cursor-notallowed" style="opacity:0.5 !important" alt="Capture Image" v-else/>
                                                                               </span>
                                                                               <span class="pr-4 pl-4 fw-600">OR</span>
                                                                          </div>
                                                                     </div>
                                                                     <!-- <div class="browse-box bg-grey-box w-100 text-center" @drop="dropAttachmentDefaultFieldAttachment($event, i)" @dragover="dragOverAttachment($event)">
                                                                          <img src="https://cdn.digicollect.com/cdn/dc_expense_fe/static/images/menu_icons/upload_icon.svg" width="30" class="pt-10 mx-auto" alt="">
                                                                          <div class="fs-14 fw-500 mt-2 text-center">Drag and Drop File</div>
                                                                          <div class="fs-14 fw-500 text-center">Or</div>
                                                                          <label class="choose-file ml-2 btn-upload" v-if="td.attachments.length < 5">
                                                                               <input id="multiple" type="file" @change="uploadDefaultFieldAttachment($event, i)" accept=".pdf,.csv,.ods,.zip,.doc,.docx,.xls,image/*">
                                                                               Browse
                                                                          </label>
                                                                          <label class="choose-file ml-2 btn-upload" style="background-color: grey;cursor: not-allowed" v-else>
                                                                               Browse
                                                                          </label>
                                                                     </div> -->
                                                                     <!-- <div class="my-3 text-center">Or</div> -->
                                                                     <div class="w-100 d-flex align-items-center justify-content-center position-relative mb-3" style="border-radius: 4px;background-color: #f1f1f1; height: 80px;">
                                                                          <span class="fs-14 position-absolute text-black" style="left: 15px; top: 8px;">Paste Image Here</span>
                                                                          <input type="text"
                                                                               @paste="handlePasteDefaultField($event, i)"
                                                                               readonly :id="'DefaultField'+i" :name="'DefaultField'+i"
                                                                               placeholder="Click here and press Ctrl + V to Paste"
                                                                               @input="handleInput"
                                                                               style="border: 0 none; outline: 0 none; min-height: 50px; padding: 10px; width: 300px; cursor: pointer !important;background-color: #f1f1f1;"
                                                                          />
                                                                     </div>
                                                                </div>
                                                                <div class="col-lg-12 col-md-6 col-sm-12" v-if="td.hasOwnProperty('attachments') && td.attachments.length > 0">
                                                                     <div class="row  w-100 text-center" style="overflow: auto;">
                                                                          <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment, attachment_index) in td.attachments" :key="attachment_index">
                                                                               <div class="d-flex align-items-center mt-2 file-bg">
                                                                                    <div class="d-flex align-items-center" style="width:90%">
                                                                                         <div>
                                                                                              <img src="/static/images/storage.svg" width="20">
                                                                                              <!-- <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                                                              <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                                                              <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                                                              <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                                                              <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                                                              <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                                                              <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                                                              <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                                                              <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                                                              <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/> -->
                                                                                         </div>
                                                                                         <div class="col">
                                                                                              <div class="d-flex justify-content-between">
                                                                                                   <el-tooltip :content="attachment.name" placement="top">
                                                                                                        <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                                             {{attachment.name}}
                                                                                                        </div>
                                                                                                   </el-tooltip>
                                                                                              </div>
                                                                                              <div v-if="attachment.uploading || attachment.url == undefined">
                                                                                                   <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                                                              </div>
                                                                                              <!-- <div class="d-flex justify-content-between">
                                                                                                   <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                                                                   <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                                                                   <div class="fw-500" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                                                              </div> -->
                                                                                         </div>
                                                                                    </div>
                                                                                    <div class="pointer ml-3" style="width:10%; z-index: 1;" @click="deleteDefaultFieldAttachment(i, attachment_index)">
                                                                                    <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                                                    <img src="/static/images/delete-bin-4-line.svg" width="20" alt="" v-if="attachment.url">
                                                                                    <!-- <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url"></i> -->
                                                                                    </div>
                                                                               </div>
                                                                          </div>
                                                                     </div>
                                                                </div>
                                                                <div v-else class="col-lg-8 col-md-6 col-sm-12 pl-0 pl-med-12">
                                                                     <div class="browse-box dotted-grey w-100 text-center">
                                                                          <div class="no-att-msg"> 
                                                                               <span class="fs-20 fw-500">No Attachments Added</span>
                                                                          </div>
                                                                     </div>
                                                                </div>
                                                           </div>
                                                           <span class="invalid-feedback-form text-danger mt-0" v-if="td.attachment_error">Attachments for this field is required</span>
                                                      </div>
                                                 </div>
                                            </div>
                                            <div>
                                                 <!-- Short Answer Validations -->
                                                 <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('short_answer'+ i)">{{errors.first('short_answer'+ i)}}</span>
                                                 <!-- Long Answer Validations -->
                                                 <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('long_answer'+ i)">{{errors.first('long_answer'+ i)}}</span>
                                                 <!-- Check box Validations -->
                                                 <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('check_box'+ i)">{{errors.first('check_box'+ i)}}</span>
                                                 <!-- Radio check Validations -->
                                                 <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('radio_button'+ i)">{{errors.first('radio_button'+ i)}}</span>
                                                 <!-- Drop down Validations -->
                                                 <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('drop_down'+ i)">{{errors.first('drop_down'+ i)}}</span>
                                                 <!-- SCM Products Drop down Validations -->
                                                 <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('apidrop_down'+ i)">The Dropdown Field Is Required</span>
                                                 <!-- Tags Validations -->
                                                 <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('tags'+ i)">{{errors.first('tags'+ i)}}</span>
                                                 <!-- Date Validations -->
                                                 <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('date'+ i)">{{errors.first('date'+ i)}}</span>
                                                 <!-- Time Validations -->
                                                 <span class="invalid-feedback-form text-danger mt-0" v-if="td.required && td.answer == ''" v-show="errors.has('time'+ i)">{{errors.first('time'+ i)}}</span>
                                                 <!-- Date And Time Validations -->
                                                 <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('date_time'+ i)">The Date and Time field required</span>
                                                 <!-- Location Validations -->
                                                 <span class="invalid-feedback-form text-danger mt-0" v-if="td.error && td.location_details.location_vmodel == ''">The Location field is required</span>
                                            </div>
                                       </div>
                                  </div>
                             </div>
                             <div class="general-section general-box py-4 pb-6 mt-5" v-if="generalActive && template_type == 'multi_part'">
                                  <span class="list-text fs-15 fw-600 text-black">2. Ticket Details</span>
                                  <div class="dynamic-section px-5  mt-4 py-4" :class="field.approval_status == 'approved' || field.approval_status == 'upcoming' ? 'bg-white' : ''" v-for="(field, field_index) in editTicketTemplate" :key="field_index">
                                       <div class="infoHeader mt-2">
                                            <div class="descriptionheader">
                                                 <!-- <div class="description-text-header-left">
                                                      <h5 class="font-weight-bold text-black whiteSpace" :title="field.part_name">{{ field.part_name.split('').length > 1 ?  field.part_name[0].toUpperCase() +''+ field.part_name.slice(1,) : field.part_name[0].toUpperCase()}}</h5>
                                                 </div> -->
                                                 <!-- <div class="description-text-header-right">
                                                      <div v-if="field.approval_status == 'pending' || field.approval_status == 'approved'" :class="$route.path.startsWith('/ticketdetails/view/') && $route.query.type == 'review_ticket' && $route.query.part_name != field.part_name && field.approval_status != 'approved' ? 'display-none' : ''">
                                                           <span class="collapse-addon" v-if="field.show">
                                                                <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" @click="ToggleParts(field)" alt="" style="top: 9px !important;transition:0.5s">
                                                           </span>
                                                           <span class="collapse-addon" v-else>
                                                                <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" alt="" @click="ToggleParts(field)" style="top: 9px !important;transform: rotate(180deg);transition:0.5s">
                                                           </span>
                                                      </div>
                                                 </div> -->
                                                      <div class="capture-image d-flex align-items-center p-2 px-4">
                                                           <span class="text-new-header-black fw-500 mr-3"
                                                           style="width: max-content;min-width: max-content;" :title="field.part_name">{{ field.part_name.split('').length > 1 ?  field.part_name[0].toUpperCase() +''+ field.part_name.slice(1,) : field.part_name[0].toUpperCase()}}</span>
                                                           <div class="inner-line-hr w-100"></div>
                                                           <div v-if="field.approval_status == 'pending' || field.approval_status == 'approved'" :class="$route.path.startsWith('/ticketdetails/view/') && $route.query.type == 'review_ticket' && $route.query.part_name != field.part_name && field.approval_status != 'approved' ? 'display-none' : ''">
                                                           <img v-if="field.show" class="pointer capture-image-rotate"
                                                           @click="ToggleParts(field)" src="/static/images/etherum-fill.svg" width="24"
                                                           height="24">
                                                           <img v-else class="pointer capture-image-rotate" @click="ToggleParts(field)"
                                                           src="/static/images/new-theme2024/etherum-line.png" width="24" height="24">
                                                      </div>
                                                 </div>
                                            </div>
                                       </div>
                                       <div class="row" v-if="editTicketTemplate.length > 0 && field.show" :class="$route.path.startsWith('/ticketdetails/view/') && $route.query.type == 'review_ticket' && $route.query.part_name != field.part_name && field.approval_status != 'approved' ? 'display-none' : ''">
                                            <div class="col-lg-12 col-md-12 col-sm-12 mt-5" v-for="(td, i) in field.parts_data" :key='i'>
                                                 <div class="d-flex flex-column justify-content-start h-100"> 
                                                      <div class="fw-600 pt-2 pb-2 fs-13 text-black d-inline-block w-100 overflowing-text" :title="td.name">{{td.name.split('').length > 1 ?  td.name[0].toUpperCase() +''+ td.name.slice(1,) : td.name[0].toUpperCase()}}<span class="text-danger" v-if="td.required == true"> *</span></div>
                                                      <div>
                                                           <div v-if="ticketType.name == 'Digicollect Product Template'">
                                                                <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                                                     v-model="td.answer" track-by="_id"
                                                                     class="diginew-multiselect arrow-custom mt-3"
                                                                     :loading="apicall_loading"
                                                                     :options="scm_products_options"
                                                                     :searchable="true"
                                                                     :disabled="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'"
                                                                     :close-on-select="true"
                                                                     :name="'apidrop_down'+ field_index + i"
                                                                     :show-labels="false"
                                                                     @search-change="searchTemplateApiDD"
                                                                     @open="getTemplateApiDD"
                                                                     @close="insertMultiProductTag(td.answer)"
                                                                     :multiple="false"
                                                                     :options-limit="3000"
                                                                     :max-height="200"
                                                                     v-validate="td.required ? 'required' : ''"
                                                                     :clear-on-select="false"
                                                                     label="name"
                                                                     :internal-search="true"
                                                                     :show-no-results="true"
                                                                     :hide-selected="false"
                                                                     >
                                                                     <template slot="placeholder">
                                                                          <span v-if="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'" class="diginewhelp-multiselect">-</span>
                                                                          <span v-else class="diginewhelp-multiselect">Select Product</span>
                                                                     </template>
                                                                     <template slot="afterList">
                                                                          <div v-observe-visibility="reachedEndOfApiDD" />
                                                                     </template>
                                                                     <template slot="noResult">
                                                                          <div v-if="scm_products_options.length">
                                                                               <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                                    <div></div>
                                                                                    <div></div>
                                                                                    <div></div>
                                                                                    <div></div>
                                                                               </div>
                                                                          </div>
                                                                          <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                                                     </template>
                                                                </multiselect>
                                                           </div>
                                                           <div v-else>
                                                                <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                                                     v-model="td.answer" track-by="_id"
                                                                     class="diginew-multiselect arrow-custom mt-3"
                                                                     :loading="apicall_loading"
                                                                     :options="scm_products_options"
                                                                     :searchable="true"
                                                                     :close-on-select="true"
                                                                     :disabled="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'"
                                                                     :name="'apidrop_down' + field_index + i"
                                                                     :show-labels="false"
                                                                     @search-change="searchApiDD"
                                                                     @open="getApiDD"
                                                                     @close="insertMultiProductTag(td.answer)"
                                                                     :multiple="false"
                                                                     :options-limit="3000"
                                                                     :max-height="200"
                                                                     v-validate="td.required ? 'required' : ''"
                                                                     :clear-on-select="false"
                                                                     label="name"
                                                                     :internal-search="true"
                                                                     :show-no-results="true"
                                                                     :hide-selected="false"
                                                                     >
                                                                     <template slot="placeholder">
                                                                          <span v-if="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'" class="diginewhelp-multiselect">-</span>
                                                                          <span v-else class="diginewhelp-multiselect">Select Product</span>
                                                                     </template>
                                                                     <template slot="afterList">
                                                                          <div v-observe-visibility="reachedEndOfApiDD" />
                                                                     </template>
                                                                     <template slot="noResult">
                                                                          <div v-if="scm_products_options.length">
                                                                               <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                                    <div></div>
                                                                                    <div></div>
                                                                                    <div></div>
                                                                                    <div></div>
                                                                               </div>
                                                                          </div>
                                                                          <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                                                     </template>
                                                                </multiselect>
                                                           </div>
                                                           <!-- Short Answer -->
                                                           <input v-if="td.type == 'short_answer'"
                                                           class="border-bottom-custom inputFieldNew"
                                                           style="padding-right: 30px !important;"
                                                           type="text"
                                                           :disabled="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'"
                                                           maxlength="100"
                                                           v-model="td.answer"
                                                           :placeholder="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved' ? '-' : 'Enter Short Answer'"
                                                           :name="'short_answer' + field_index + i"
                                                           v-validate="td.required ? 'required' : ''"
                                                           data-vv-as="Short Answer"
                                                           />
                                                           <!-- Radiobutton -->
                                                           <el-radio-group v-if="td.type == 'radio_button'" class="d-flex align-items-center mt-5 mob-issue-fix block-dis  w-100" v-model="td.answer" v-validate="td.required ? 'required' : ''" :name="'radio_button' + field_index + i" data-vv-as="Radio Button" :disabled="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'">
                                                                <div class="row">
                                                                     <el-radio class="col-xl-2 col-lg-2 col-md-6 col-sm-6 w-150 text-capitalize  d-flex word-wrap" :label="radio_options" v-for="(radio_options, ri) in td.possible_values" :key="ri">
                                                                          {{radio_options}}
                                                                     </el-radio>
                                                                </div>
                                                           </el-radio-group>
                                                           <!-- Checkbox -->
                                                           <el-checkbox-group v-if="td.type == 'check_box'" class="refund-checkbox mt-4  w-100" v-validate="td.required ? 'required' : ''" :name="'check_box' + field_index + i" data-vv-as="Check Box" v-model="td.answer" :disabled="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'">
                                                                <div class="row">
                                                                     <el-checkbox class="col-xl-2 col-lg-2 col-md-6 col-sm-6 w-150 text-capitalize d-flex word-wrap" :label="check_options" v-for="(check_options, ci) in td.possible_values" :key="ci">
                                                                          {{check_options}}
                                                                     </el-checkbox>
                                                                </div>
                                                           </el-checkbox-group>
                                                           <!-- Date -->
                                                           <date-picker v-if="td.type == 'date'" :disabled="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'"
                                                                class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor" :placeholder="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved' ? '-' : 'MM/DD/YYYY'"
                                                                v-validate="td.required ? 'required' : ''"
                                                                :name="'date' + field_index + i"
                                                                data-vv-as="Date" onkeypress="return event.charCode >= 47 && event.charCode <= 57"
                                                                value-type="format" :editable="true"
                                                                format="MM/DD/YYYY" type="date" lang="en" v-model="td.answer"
                                                                style="border:none !important">
                                                           </date-picker>
                                                           <!-- Time -->
                                                           <date-picker v-if="td.type == 'time'"
                                                                v-model="td.answer" :disabled="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'"
                                                                format="hh:mm A"
                                                                :name="'time' + field_index + i"
                                                                data-vv-as="Time"
                                                                class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-clock-icon"
                                                                type="time" onkeypress="return event.charCode >= 48 && event.charCode <= 58"
                                                                :placeholder="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved' ? '-' : 'Enter the time'"
                                                                lang="en"
                                                                value-type="format"
                                                                :clearable="false"
                                                                :editable="true"
                                                                @confirm="HandleTimeEventMultiPart($event, field_index, i, 'time')"
                                                                :minute-step="1"
                                                                confirm
                                                                confirm-text="APPLY"
                                                                v-validate="td.required ? 'required' : ''"
                                                           ></date-picker>
                                                           <!-- Date and time -->
                                                           <div class="d-flex align-items-center" v-if="td.type == 'date_time'">
                                                                <div class="row">
                                                                     <date-picker v-if="td.type == 'date_time'"
                                                                     class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor mt-3 col-lg-6 col-md-6 col-sm-12" 
                                                                     :placeholder="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved' ? '-' : 'MM/DD/YYYY'"
                                                                     v-validate="td.required ? 'required' : ''"
                                                                     :name="'date_time' + field_index + i" :disabled="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'"
                                                                     data-vv-as="Date" onkeypress="return event.charCode >= 47 && event.charCode <= 57"
                                                                     value-type="format" :editable="true"
                                                                     format="MM/DD/YYYY" type="date" lang="en" v-model="td.date"
                                                                     style="border:none !important">
                                                                     </date-picker>
                                                                     <date-picker v-if="td.type == 'date_time'"
                                                                     v-model="td.time"
                                                                     format="hh:mm A" :disabled="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'"
                                                                     :name="'date_time' + field_index + i"
                                                                     data-vv-as="Time"
                                                                     class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-clock-icon mt-3 col-lg-6 col-md-6 col-sm-12"
                                                                     type="time" onkeypress="return event.charCode >= 48 && event.charCode <= 58"
                                                                     :placeholder="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved' ? '-' : 'Enter the time'"
                                                                     lang="en"
                                                                     value-type="format"
                                                                     :clearable="false"
                                                                     :editable="true"
                                                                     @confirm="HandleTimeEventMultiPart($event, field_index, i, 'date_time')"
                                                                     :minute-step="1"
                                                                     confirm
                                                                     confirm-text="APPLY"
                                                                     v-validate="td.required ? 'required' : ''"
                                                                     ></date-picker>
                                                                </div>
                                                           </div>
                                                           <!-- Description -->
                                                           <textarea :placeholder="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved' ? '-' : 'Enter Long Answer'"  maxlength="500" v-validate="td.required ? 'required' : ''" 
                                                           :disabled="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'"
                                                           :name="'long_answer' + field_index + i" data-vv-as="Long Answer" v-if="td.type == 'long_answer'" v-model="td.answer" 
                                                           class="desc-textarea mt-3"></textarea>
                                                           <!-- Dropdown -->
                                                           <multiselect
                                                                v-if="td.type == 'drop_down' && td.is_api_call_required == false"
                                                                v-validate="td.required ? 'required' : ''" style="width: 250px !important"
                                                                class="diginew-multiselect border-bottom-custom arrow-custom fs-15 mt-3"
                                                                :name="'drop_down' + field_index + i" :disabled="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'"
                                                                data-vv-as="Drop Down"
                                                                v-model="td.answer"
                                                                :options="td.possible_values"
                                                                :searchable="true"
                                                                :close-on-select="true"
                                                                :show-labels="false"
                                                           >
                                                                <template slot="placeholder" v-if="!$route.path.startsWith('/ticketdetails/view/') || field.approval_status != 'approved'">
                                                                     <span v-if="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'" class="diginewhelp-multiselect">-</span>
                                                                     <span v-else class="diginewhelp-multiselect">Select Dropdown</span>
                                                                </template>
                                                           </multiselect>
                                                           <!-- Tags -->
                                                           <vue-tags-input v-if="td.type == 'tag'" :name="'tags' + field_index + i" 
                                                                :disabled="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'" 
                                                                @tags-changed="tagsChangeMultiData($event, field_index, i, 'by-field')" :delete-on-backspace="false"
                                                                data-vv-as="Tags" v-model="td.entered_tag" v-validate="td.required && td.answer.length == 0 ? 'required' : ''" 
                                                                class="multi_part-sec border-bottom-custom inputFieldNew-tags create-edit-ticket-tags rel-x2 mt-3" :tags="td.answer" 
                                                                maxlength="40" :placeholder="ticketType.name == 'Digicollect Product Template' || ticketType.name == 'Product Bug Template' ? 'Add Custom Tags' : ($route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved') && td.answer.length == 0 ? 'No Data' : 'Enter Tags Here'" id='to_email' />
                                                           <!-- Location -->
                                                           <div v-if="td.type == 'location'">
                                                                <div class="digi-table-loader d-flex justify-content-center" v-if="location_loader" id="spinner" style="margin: 0 auto;position:absolute">
                                                                     <div></div>
                                                                     <div></div>
                                                                     <div></div>
                                                                     <div></div>
                                                                </div>
                                                                <div class="form-group contactGroup pt-0">
                                                                     <div class="d-flex align-items-center">
                                                                          <div class="form-group gMap" style="position:relative;width:100%;">
                                                                          <input class="inputFieldNew overflowing-text mt-0 border-bottom-custom" style="padding-right: 30px !important;" :name="'location' + field_index + i" disabled type="text" v-model="td.location_details.location_vmodel" :placeholder="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved' ? '-' : 'Enter Location'" />
                                                                          <div class="d-flex">
                                                                               <i class="icon icon-map-marker color-blue" style="position: absolute;right: 5px;bottom: 9px;"></i>
                                                                          </div>
                                                                          </div>
                                                                          <div v-if="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'" class="gps-logo" :id="'DisableOnClick' + i + field_index" style="opacity: .5;cursor: not-allowed;">
                                                                               <i class="icon-crosshairs-gps color-blue" ></i>
                                                                          </div>
                                                                          <div v-else class="gps-logo pointer" :id="'DisableOnClick' + i + field_index" @click="getMultiPartLocation(field_index ,i)">
                                                                               <i class="icon-crosshairs-gps color-blue" ></i>
                                                                          </div>
                                                                     </div>
                                                                </div>
                                                           </div>
                                                           <div v-if="td.statement">
                                                                <textarea v-model="td.reason" class="text-reason" :disabled="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved'" 
                                                                :placeholder="$route.path.startsWith('/ticketdetails/view/') || field.approval_status == 'approved' ? 'No Data' : 'Enter a reason'" 
                                                                v-validate="td.required ? 'required' : ''" :name="`reason${field_index}${i}`"  data-vv-as="Reason"></textarea>
                                                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has(`reason${i}`)">
                                                                     {{errors.first(`reason${field_index}${i}`)}}
                                                                </span>
                                                           </div>
                                                           <div v-if="td.add_attachments && ( $route.path.startsWith('/ticketdetails/view/') || $route.path.startsWith('/ticketdetails/edit/') && field.approval_status == 'approved' && is_approvers_mandatory)"> 
                                                                <div v-if="td.hasOwnProperty('attachments')">
                                                                     <div v-if="td.attachments.length <= 0">
                                                                          <div class="fw-500 fs-15px mt-3">Attachment</div>
                                                                          <div class="font-weight-bold fs-15px mt-2">No Attachment Added</div>
                                                                     </div>
                                                                     <div v-else class="mt-3">
                                                                          <span class="fw-500 fs-15px">Attachment</span>
                                                                          <div class="row mt-2 justify-content-frsm">
                                                                               <div class="col-lg-4 col-md-5 col-sm-12" v-for="(attachment, att_index) in td.attachments" :key="att_index">
                                                                                    <div class="d-flex align-items-center mt-2 file-bg">
                                                                                         <div class="d-flex align-items-center" style="width:90%">
                                                                                              <div class="pointer" @click="previewImage(attachment)">
                                                                                                   <img src="/static/images/storage.svg" width="20">
                                                                                                   <!-- <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                                                                   <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/> -->
                                                                                              </div>
                                                                                              <div class="col">
                                                                                                   <div class="d-flex justify-content-between">
                                                                                                        <el-tooltip :content="attachment.name" placement="top">
                                                                                                        <div class="font-weight-bold text-truncate d-block mx-width-220 pointer" @click="previewImage(attachment)">
                                                                                                             {{attachment.name}}
                                                                                                        </div>
                                                                                                        </el-tooltip>
                                                                                                   </div>
                                                                                                   <div v-if="attachment.uploading || attachment.url == undefined">
                                                                                                        <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                                                                   </div>
                                                                                                   <!-- <div class="d-flex justify-content-between">
                                                                                                        <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                                                                        <div class="fw-500" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                                                                   </div> -->
                                                                                              </div>
                                                                                         </div>
                                                                                    </div>
                                                                               </div>
                                                                          </div>
                                                                     </div>
                                                                </div>
                                                           </div>
                                                           <!-- Multi Part Field Attachments -->
                                                           <div class="mt-3" v-else-if="td.add_attachments">
                                                                <span class="fw-500 fs-15px">Attachments</span>
                                                                <div class="row mt-4 justify-content-frsm">
                                                                     <div class="col-lg-12 col-md-12 col-sm-12">
                                                                          <div class="mt-4"@drop="dropAttachmentMPFieldAttachment($event, field_index, i)" @dragover="dragOverAttachment($event)">
                                                                               <div class="img-upload pl-4 pr-sm-15 pt-3 pb-3 bg-white">
                                                                                    <img width="30" src="/static/images/draganddrop.svg" class="" alt="Capture Image"/>
                                                                                    <span class="pr-4 pl-4 hide-on-mob">Drag and Drop Files Here 1</span>
                                                                                    <span class="pr-4 hide-on-mob" style="font-weight:600 !important;">OR</span>
                                                                                         <file-upload id="multiple" v-if="td.attachments.length < 5"
                                                                                              class="choose-file btn btn-new-primary"
                                                                                              type="file"
                                                                                              @input-file="uploadMPFieldAttachment($event, field_index, i)" accept=".pdf,.csv,.ods,.zip,.doc,.docx,.xls,image/*" ref="upload"
                                                                                              webkitdirectory mozdirectory
                                                                                              style="text-transform: none !important; padding:2px 18px 6px 18px !important;">
                                                                                              <i class="icon ri-upload-2-line text-white fs-15 pr-1"></i>
                                                                                              Click to Upload
                                                                                         </file-upload>
                                                                                         <label class="choose-file ml-2 btn-upload-disabled cursor-notallowed" v-else>
                                                                                              Browse Files
                                                                                         </label>
                                                                                    <span class="pr-4 pl-4" style="font-weight:600 !important;">OR</span>
                                                                                    <span class="pr-4 pointer">
                                                                                         <img width="30" @click="openCaptureImage" src="/static/images/camera-3-line.svg" alt="Capture Image" v-if="attachments.length < 10"/>
                                                                                         <img width="30" src="/static/images/camera-3-line.svg" class="cursor-notallowed" style="opacity:0.5 !important" alt="Capture Image" v-else/>
                                                                                    </span>
                                                                                    <span class="pr-4 pl-4 fw-600">OR</span>
                                                                               </div>
                                                                          </div>
                                                                          <!-- <div class="browse-box bg-grey-box w-100 text-center" @drop="dropAttachmentMPFieldAttachment($event, field_index, i)" @dragover="dragOverAttachment($event)">
                                                                               <img src="https://cdn.digicollect.com/cdn/dc_expense_fe/static/images/menu_icons/upload_icon.svg" width="30" class="pt-10 mx-auto" alt="">
                                                                               <div class="fs-14 fw-500 mt-2 text-center">Drag and Drop File</div>
                                                                               <div class="fs-14 fw-500 text-center">Or</div>
                                                                               <label class="choose-file ml-2 btn-upload" v-if="td.attachments.length < 5">
                                                                                    <input id="multiple" type="file" @change="uploadMPFieldAttachment($event, field_index, i)" accept=".pdf,.csv,.ods,.zip,.doc,.docx,.xls,image/*">
                                                                                    Browse
                                                                               </label>
                                                                               <label class="choose-file ml-2 btn-upload" style="background-color: grey;cursor: not-allowed" v-else>
                                                                                    Browse
                                                                               </label>
                                                                          </div> -->
                                                                          <!-- <div class="my-3 text-center">Or</div> -->
                                                                          <div class="w-100 d-flex align-items-center justify-content-center position-relative mb-3" style="border-radius: 4px;background-color: #f1f1f1; height: 80px;">
                                                                               <span class="fs-14 position-absolute text-black" style="left: 15px; top: 8px;">Paste Image Here</span>
                                                                               <input type="text"
                                                                               @paste="handlePasteMultiPart($event, field_index, i)"
                                                                               readonly :id="'MultiPart'+field_index+''+i" :name="'MultiPart'+field_index+''+i"
                                                                               placeholder="Click here and press Ctrl + V to Paste"
                                                                               @input="handleInput"
                                                                               style="border: 0 none; outline: 0 none; min-height: 50px; padding: 10px; width: 300px; cursor: pointer !important;background-color: #f1f1f1;"
                                                                               />
                                                                          </div>
                                                                     </div>
                                                                     <div class="col-lg-12 col-md-12 col-sm-12" style="height:200px !important;overflow: auto" v-if="td.hasOwnProperty('attachments') && td.attachments.length > 0">
                                                                          <div class="row w-100 text-center" style="overflow: auto;">
                                                                               <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment, attachment_index) in td.attachments" :key="attachment_index">
                                                                                    <div class="d-flex align-items-center mt-2 file-bg">
                                                                                         <div class="d-flex align-items-center" style="width:90%">
                                                                                              <div>
                                                                                                   <img src="/static/images/storage.svg" width="20">
                                                                                                   <!-- <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                                                                   <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                                                                   <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/> -->
                                                                                              </div>
                                                                                              <div class="col">
                                                                                                   <div class="d-flex justify-content-between">
                                                                                                        <el-tooltip :content="attachment.name" placement="top">
                                                                                                        <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                                             {{attachment.name}}
                                                                                                        </div>
                                                                                                        </el-tooltip>
                                                                                                   </div>
                                                                                                   <div v-if="attachment.uploading || attachment.url == undefined">
                                                                                                        <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                                                                   </div>
                                                                                                   <!-- <div class="d-flex justify-content-between">
                                                                                                        <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                                                                        <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                                                                        <div class="fw-500" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                                                                   </div> -->
                                                                                              </div>
                                                                                         </div>
                                                                                         <div class="pointer ml-3" style="width:10%; z-index: 1;" @click="deleteMPFieldAttachment(field_index, i, attachment_index)">
                                                                                              <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                                                              <img src="/static/images/delete-bin-4-line.svg" width="20" alt="" v-if="attachment.url">
                                                                                              <!-- <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url"></i> -->
                                                                                         </div>
                                                                                    </div>
                                                                               </div>
                                                                          </div>
                                                                     </div>
                                                                     <div v-else class="col-lg-8 col-md-6 col-sm-12 pl-0 pl-med-12">
                                                                          <div class="browse-box dotted-grey w-100 text-center">
                                                                               <div class="no-att-msg"> 
                                                                               <span class="fs-20 fw-500">No Attachments Added</span>
                                                                               </div>
                                                                          </div>
                                                                     </div>
                                                                </div>
                                                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.attachment_error">Attachments for this field is required</span>
                                                           </div>
                                                      </div>
                                                 </div>
                                                 <div>
                                                      <!-- Short Answer Validations -->
                                                      <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('short_answer' + field_index + i)">{{errors.first('short_answer' + field_index + i)}}</span>
                                                      <!-- Long Answer Validations -->
                                                      <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('long_answer' + field_index + i)">{{errors.first('long_answer' + field_index + i)}}</span>
                                                      <!-- Check box Validations -->
                                                      <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('check_box' + field_index + i)">{{errors.first('check_box' + field_index + i)}}</span>
                                                      <!-- Radio check Validations -->
                                                      <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('radio_button' + field_index + i)">{{errors.first('radio_button' + field_index + i)}}</span>
                                                      <!-- Drop down Validations -->
                                                      <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('drop_down' + field_index + i)">{{errors.first('drop_down' + field_index + i)}}</span>
                                                      <!-- SCM Products Drop down Validations -->
                                                      <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('apidrop_down' + field_index + i)">The Dropdown Field Is Required</span>
                                                      <!-- Tags Validations -->
                                                      <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('tags' + field_index + i)">{{errors.first('tags' + field_index + i)}}</span>
                                                      <!-- Date Validations -->
                                                      <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('date' + field_index + i)">{{errors.first('date' + field_index + i)}}</span>
                                                      <!-- Time Validations -->
                                                      <span class="invalid-feedback-form text-danger mt-0" v-if="td.required && td.answer == ''" v-show="errors.has('time' + field_index + i)">{{errors.first('time' + field_index + i)}}</span>
                                                      <!-- Date And Time Validations -->
                                                      <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('date_time' + field_index + i)">The Date and Time field required</span>
                                                      <!-- Location Validations -->
                                                      <span class="invalid-feedback-form text-danger mt-0" v-if="td.error && td.location_details.location_vmodel == ''">The Location field is required</span>
                                                 </div>
                                            </div>
                                       </div>
                                       <div class="infoHeader mt-4" v-if="$route.path.startsWith('/ticketdetails/view/') && field.hasOwnProperty('approval_details') && field.show" :class="$route.path.startsWith('/ticketdetails/view/') && $route.query.type == 'review_ticket' && $route.query.part_name != field.part_name && field.approval_status != 'approved' ? 'display-none' : ''">
                                            <div class="descriptionheader">
                                                 <div class="description-text-header-left align-items-center d-flex">
                                                      <h5 class="fw-500 fs-15 text-black whiteSpace mr-3 mb-0">Approval Details</h5>
                                                      <div class="inner-line-hr w-100"></div>
                                                 </div>
                                                 <div class="description-text-header-right"></div>
                                            </div>
                                       </div>
                                       <div class="table-content mb-3 mt-3" style="overflow-x: auto !important;" 
                                            v-if="$route.path.startsWith('/ticketdetails/view/') && field.hasOwnProperty('approval_details') && field.show" 
                                            :class="$route.path.startsWith('/ticketdetails/view/') && $route.query.type == 'review_ticket' && $route.query.part_name != field.part_name && field.approval_status != 'approved' ? 'display-none' : ''">
                                            <table class="table table-content-data table-content-data-custom  table-responsive">
                                                 <thead>
                                                      <tr>
                                                           <th class="whiteSpace test-white w-1" style="border-top-left-radius:5px;">
                                                                ACTION 
                                                           </th>
                                                           <th class="whiteSpace w-1" style="">
                                                                NAME
                                                           </th>
                                                           <th class="whiteSpace w-1" style="">
                                                                TITLE
                                                           </th>
                                                           <th class="whiteSpace w-1" style="">
                                                                DATE & TIME
                                                           </th>
                                                           <th class="whiteSpace w-1" style="">
                                                                COMMENTS
                                                           </th>
                                                           <th class="whiteSpace w-1" style="">
                                                                STATUS
                                                           </th>
                                                           <th class="whiteSpace w-1" style="border-top-right-radius: 5px">
                                                                ATTACHMENTS
                                                           </th>
                                                      </tr>
                                                 </thead>
                                                 <tbody>
                                                      <tr v-if="field.approval_details.length == 0">
                                                           <td colspan="7" class="text-center font-weight-bold">No Logs Found</td>
                                                      </tr>
                                                      <tr v-for="(log, log_index) in field.approval_details" :key="log_index">
                                                           <td class="whiteSpace w-1 pointer"
                                                           style="">
                                                                {{log.action || '-'}}
                                                           </td>
                                                           <td class="whiteSpace w-1 pointer" style="">
                                                                {{ log.name.name || log.name || '-'}}
                                                           </td>
                                                           <td class="whiteSpace w-1 pointer" style="">
                                                                {{ log.title || '-'}}
                                                           </td>
                                                           <td class="whiteSpace w-1 pointer" style="">
                                                                {{ log.datetime || '-'}}
                                                           </td>
                                                           <td class="w-1 pointer overloading-text" style="white-space: normal !important;">
                                                                <div class="overflowing-text text-nowrap w-200px" :title="log.comment || '-'">
                                                                     {{ log.comment || '-'}}
                                                                </div>
                                                           </td>
                                                           <td class="whiteSpace w-1 pointer ">
                                                                <div class="btn status-btn w-100px fs-14" style="text-transform: capitalize;" :class="{'btn-open-status-newtheme':log.status == 'Open',
                                                                     'btn-assigned':log.status == 'Assigned',
                                                                     'btn-review':log.status == 'Review' || log.status == 'Send For Approval' || log.status == 'Sent For Approval',
                                                                     'btn-hex-gray38':log.status == 'Unassigned',
                                                                     'btn-grid-inprogress-newtheme':log.status == 'In progress',
                                                                     'btn-fixed-newtheme':log.status == 'Fixed',
                                                                     'btn-closed-newtheme':log.status == 'Closed', 
                                                                     'btn-reopen-newtheme':log.status == 'Re-Open',
                                                                     'btn-moonlight-sage':log.status == 'Reject', 
                                                                     'btn-schedule':log.status == 'Scheduled',
                                                                     'btn-approved':log.status == 'Approved',
                                                                     'rejected-btn':log.status == 'Rejected'}">
                                                                     {{ log.status == 'Send For Approval' || log.status == 'Sent For Approval' ? 'Pending' : log.status }}
                                                                </div>
                                                           </td>
                                                           <td class="whiteSpace w-1">
                                                                <div v-if="log.hasOwnProperty('attachments') && log.attachments.length > 0"> 
                                                                     <span class="pointer underline" @click="viewLogAttachments(log.attachments)">View Attachments</span> 
                                                                </div>
                                                                <div v-else>
                                                                     No Attachments
                                                                </div>
                                                           </td>
                                                      </tr>
                                                 </tbody>
                                            </table>
                                       </div>
                                       <div class="general-section mt-4 d-flex justify-content-center" v-if=" field.hasOwnProperty('attach_files') && field.attach_files.length > 0 && field.show && ($route.path.startsWith('/ticketdetails/view/') || $route.path.startsWith('/ticketdetails/edit/') && field.approval_status == 'approved')">
                                            <div class="attachment-bg attachment-bg-new pb-8">
                                                 <div class="d-flex flex-wrap align-items-center" :class="$route.query.type!='review_ticket' && $route.path.startsWith('/ticketdetails/edit/') && field.approval_status == 'pending' ? 'mt-4' : ''">
                                                      <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment,index) in field.attach_files" :key="index">
                                                           <div class="d-flex align-items-center mt-6 file-bg">
                                                                <div class="d-flex align-items-center" style="width:90%">
                                                                     <div @click="previewImage(attachment)" class="pointer">
                                                                          <img src="/static/images/storage.svg" width="20">
                                                                          <!-- <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.mp3')" src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp3-icon.svg" style="width:40px; height:40px"/>
                                                                          <img v-else-if="attachment.name.endsWith('.mp4')" src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp4-icon.svg" style="width:40px; height:40px"/>
                                                                          <img v-else-if="attachment.name.endsWith('.MOV') || attachment.name.endsWith('.mov')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" style="width:40px; height:40px"/>
                                                                          <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/> -->
                                                                          <!-- <img v-else-if="attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')"  src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" style="width:40px; height:40px"/> -->
                                                                     </div>
                                                                     <div class="col">
                                                                          <div class="d-flex justify-content-between">
                                                                               <el-tooltip :content="attachment.name" placement="top">
                                                                                    <div class="font-weight-bold text-truncate d-block mx-width-220 pointer" @click="previewImage(attachment)">
                                                                                    {{attachment.name}}
                                                                                    </div>
                                                                               </el-tooltip>
                                                                          </div>
                                                                          <div v-if="attachment.uploading || attachment.url == undefined">
                                                                               <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                                          </div>
                                                                          <!-- <div class="d-flex justify-content-between">
                                                                               <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                                               <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                                               <div class="fw-500" v-if="attachment.size">({{attachment.size * 0.001 + ' KB' | prettyBytes}})</div>
                                                                          </div> -->
                                                                     </div>
                                                                </div>
                                                           </div>
                                                      </div>
                                                 </div>
                                            </div>
                                       </div>
                                       <div class="general-section pb-6 d-flex justify-content-center" v-if="field.show && $route.query.type!='review_ticket' && $route.path.startsWith('/ticketdetails/edit/') && field.approval_status == 'pending'">
                                            <div class="attachment-bg attachment-bg-new pb-8">
                                                 <div class="d-flex justify-content-start mb-4">
                                                      <div class="img-upload pt-3 pb-3 text-center bg-white" @drop="dropAttachment($event, field_index)" @dragover="dragOverAttachment($event)">
                                                           <img width="30" src="/static/images/draganddrop.svg" class="" alt="Capture Image"/>
                                                           <span class="pr-4 pl-2 hide-on-mob">Drag and Drop Files Here</span>
                                                           <span class="pr-4 hide-on-mob fw-600">OR</span>
                                                           <label class="choose-file ml-2 btn-upload" v-if="field.attach_files.length < 10">
                                                                <!-- <img src="/static/images/menu_icons/upload-icon-button.png" width="25" height="25" alt=""> -->
                                                                <!-- <input id="multiple" type="file" @change="uploadAttachmentByPart($event, field_index)" accept=".pdf,.csv,.ods,.zip,.doc,.docx,.xls,image/*"> -->
                                                                <file-upload id="multiple"
                                                                     class="choose-file btn btn-new-primary"
                                                                     accept=".pdf,.csv,.ods,.zip,.doc,.docx,.xls,image/*"                                                                      
                                                                     @change="uploadAttachmentByPart($event, field_index)"
                                                                     webkitdirectory mozdirectory
                                                                     style="text-transform: none !important; padding:2px 18px 6px 18px !important;">
                                                                     <i class="icon ri-upload-2-line text-white fs-15 pr-1"></i>
                                                                     Click to Upload
                                                                </file-upload>                                                            
                                                           </label>
                                                           <label class="choose-file ml-2 cursor-notallowed btn-upload-disabled" v-else>
                                                                <!-- <img src="/static/images/menu_icons/upload-icon-button.png" width="25" height="25" alt=""> -->
                                                                <!-- <input id="multiple" type="file" @change="uploadAttachmentByPart($event, field_index)" accept=".pdf,.doc,.xls,image/*"> -->
                                                                 Click to Upload
                                                           </label>
                                                           <span class="pr-4 pl-4 fw-600">OR</span>
                                                           <span class="pr-4 pointer">
                                                           <img width="30" v-if="field.attach_files.length < 10" @click="openCaptureImageMulti(field_index)" src="/static/images/camera-3-line.svg" alt="Capture Image" />
                                                           <img width="30" v-else src="/static/images/camera-3-line.svg" style="opacity:.5 !important" class="cursor-notallowed" alt="Capture Image" />
                                                           </span>
                                                           <span class="ml-4 text-center fw-600">OR</span>
                                                      </div>
                                                 </div>
                                                 <!-- <div class="my-3 text-center">Or</div> -->
                                                 <div class="w-100 d-flex align-items-center justify-content-center position-relative mb-3" style="border-radius: 4px;background-color: #f1f1f1; height: 80px;">
                                                      <span class="fs-14 position-absolute text-black" style="left: 15px; top: 8px;">Paste Image Here</span>
                                                      <input type="text"
                                                      @paste="handlePasteByPart($event, field_index)"
                                                      readonly :id="'ByPart'+field_index" :name="'ByPart'+field_index"
                                                      placeholder="Click here and press Ctrl + V to Paste"
                                                      @input="handleInput"
                                                      style="border: 0 none; outline: 0 none; min-height: 50px; padding: 10px; width: 300px; cursor: pointer !important;background-color: #f1f1f1;"
                                                      />
                                                 </div>
                                                 <div class="d-flex flex-wrap align-items-center" :class="$route.query.type!='review_ticket' && $route.path.startsWith('/ticketdetails/edit/') && field.approval_status == 'pending' ? 'mt-4' : ''">
                                                      <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment,index) in field.attach_files" :key="index">
                                                           <div class="d-flex align-items-center mt-6 file-bg">
                                                                <div class="d-flex align-items-center" style="width:90%">
                                                                     <div>
                                                                          <img src="/static/images/storage.svg" width="20">
                                                                          <!-- <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                                          <img v-else-if="attachment.name.endsWith('.mp3')" src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp3-icon.svg" style="width:40px; height:40px"/>
                                                                          <img v-else-if="attachment.name.endsWith('.mp4')" src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp4-icon.svg" style="width:40px; height:40px"/>
                                                                          <img v-else-if="attachment.name.endsWith('.MOV') || attachment.name.endsWith('.mov')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" style="width:40px; height:40px"/>
                                                                          <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/> -->
                                                                          <!-- <img v-else-if="attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')"  src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" style="width:40px; height:40px"/> -->
                                                                     </div>
                                                                     <div class="col">
                                                                          <div class="d-flex justify-content-between">
                                                                               <el-tooltip :content="attachment.name" placement="top">
                                                                                    <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                    {{attachment.name}}
                                                                                    </div>
                                                                               </el-tooltip>
                                                                          </div>
                                                                          <div v-if="attachment.uploading || attachment.url == undefined">
                                                                               <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                                          </div>
                                                                          <!-- <div class="d-flex justify-content-between">
                                                                               <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                                               <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                                               <div class="fw-500" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                                          </div> -->
                                                                     </div>
                                                                </div>
                                                                <div class="pointer ml-3" style="width:10%" @click="deleteAttachmentByPart(attachment,field_index)">
                                                                     <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                                     <img src="/static/images/delete-bin-4-line.svg" width="20" alt="" v-if="attachment.url && attachment.uploading == false">
                                                                     <!-- <i class="icon icon-trash text-secondary fs-20" v-else-if="attachment.url && attachment.uploading == false"></i> -->
                                                                </div>
                                                           </div>
                                                      </div>
                                                 </div>
                                                 <modal
                                                      transition="nice-modal-fade"
                                                      class="new-modal-default emergency-contact-list"
                                                      :name="`capture-image${field_index}`"
                                                      v-if="show_capture_image_multi"
                                                      :delay="100"
                                                      height="auto"
                                                      :width="400"
                                                      :adaptive="true" :scrollable="true"
                                                 >
                                                      <div class="v-modal-content" style="border-radius: 15px;background-color: #ebf3ff !important;">
                                                           <div class="v-modal-body">
                                                           <div class="v-modal-layout d-flex justify-content-center">
                                                                <div id="app" class="web-camera-container mt-10">
                                                                     <div v-show="isCameraOpen && isLoading" >
                                                                          <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/>
                                                                     </div>
                                                                     <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                                                                          <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                                                                          <video v-show="!isPhotoTaken" ref="camera_capture" :width="250" :height="250" autoplay></video>
                                                                          <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="250" :height="250"></canvas>
                                                                     </div>
                                                                </div>
                                                           </div>
                                                           </div>
                                                           <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                                                           <a class="btn btn-danger btn-smm text-white" style="text-transform: uppercase !important;font-size: 12px !important;" @click="hideViewMultiPart(field_index)">CANCEL</a>
                                                           <button :disabled="!(isCameraOpen && !isLoading)" v-if="isCameraOpen && !isPhotoTaken" @click="takePhotoMultiPart(field_index)" type="button" class="btn btn-success btn-smm text-white ml-4" style="box-shadow: none;">
                                                                Capture
                                                           </button>
                                                           <button :disabled="!(isCameraOpen && !isLoading)" v-if="isPhotoTaken && isCameraOpen" @click="downloadImageByPart(field_index)" type="button" class="btn btn-success btn-smm text-white ml-4" style="box-shadow: none;">
                                                                Upload
                                                           </button>
                                                           </div>
                                                      </div>
                                                 </modal>
                                            </div>
                                       </div>
                                  </div>
                             </div>
                             <div class="general-section general-box pt-2 pb-6 mt-4 d-flex justify-content-center px-4" v-if="template_type != 'multi_part' && !$route.path.startsWith('/ticketdetails/view/') && $route.query.type!='review_ticket'">
                                  <div class="attachment-bg attachment-bg-new pb-8">
                                       <div class="text-black ml-2 fw-600 fs-15 mt-2">Upload Files</div>
                                  <div class="d-flex justify-content-start mt-4" @drop="dropDefaultAttachment($event)" @dragover="dragOverAttachment($event)">
                                       <img width="30" src="/static/images/draganddrop.svg" class="mr-4" alt="Capture Image"/>
                                       <div class="img-upload mr-4 pt-3 pb-3 text-center bg-white">
                                            <span class="pr-8 hide-on-mob">Drag and Drop Files Here</span>
                                            <span class="pr-8 hide-on-mob fw-600 ">OR</span>
                                                 <file-upload id="multiple"
                                                      class="choose-file btn btn-new-primary pr-8"
                                                      :multiple="true" v-if="attachments.length < 10"
                                                      :size="size || 0"
                                                      :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                                                      :headers="headers"
                                                      accept=".doc, .docx, .htm, .html, .pdf, .ppt, .pptx, .txt, .Xls, .xlsx, .bmp, .gif, .jpeg, .png, .svg, .tiff, .avi, .flv, .mpg, .mpeg, .mp3, .mp4, .wav, .wmv, .mov,.csv,.ods,.zip,"
                                                      @input-file="uploadAttachment" ref="upload"
                                                      webkitdirectory mozdirectory
                                                      :add-index="addIndex"
                                                      style="text-transform: none !important; padding:2px 18px 6px 18px !important;">
                                                      <i class="icon ri-upload-2-line text-white fs-15 pr-1"></i>
                                                      Click to Upload
                                                 </file-upload>
                                                 <label class="choose-file ml-2 cursor-notallowed btn-upload-disabled" v-else>
                                                      Click to Upload
                                                 </label>
                                                 <span class="pr-8 hide-on-mob pl-8 fw-600 ">OR</span>
                                            <span class="pr-4 pointer">
                                                 <img width="30" @click="openCaptureImage" src="/static/images/camera-3-line.svg" alt="Capture Image" v-if="attachments.length < 10" />
                                                 <img width="30" v-else src="/static/images/camera-3-line.svg" style="opacity:.5 !important" class="cursor-notallowed" alt="Capture Image" />
                                            </span>
                                            <span class="pr-4 hide-on-mob fw-600 ">OR</span>
                                       </div>
                                  </div>
                                  <!-- <div class="my-3 text-center">Or</div> -->
                                  <div class="w-100 d-flex align-items-center justify-content-center position-relative mb-3" style="border-radius: 4px;background-color: #f1f1f1; height: 80px;">
                                       <span class="fs-14 position-absolute text-black" style="left: 15px; top: 8px;">Paste Image Here</span>
                                       <input type="text"
                                            @paste="handlePasteDefaultAttachment"
                                            readonly :id="'DefaultAttachment'" :name="'DefaultAttachment'"
                                            placeholder="Click here and press Ctrl + V to Paste"
                                            @input="handleInput"
                                            style="border: 0 none; outline: 0 none; min-height: 50px; padding: 10px; width: 300px; cursor: pointer !important;background-color: #f1f1f1;"
                                       />
                                  </div>
                                  <!-- <div class="example-full">
                                       <div class="btn-group" style="display: none;">
                                            <file-upload
                                                 class="btn btn-primary dropdown-toggle"
                                                 :multiple="multiple"
                                                 :directory="directory"
                                                 :size="size || 0"
                                                 :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                                                 :headers="headers"
                                                 :add-index="addIndex"
                                                 v-model="temp_attachments"
                                                 accept=".doc, .docx, .htm, .html, .pdf, .ppt, .pptx, .txt, .Xls, .xlsx, .bmp, .gif, .jpeg, .png, .svg, .tiff, .avi, .flv, .mpg, .mpeg, .mp3, .mp4, .wav, .wmv, .mov"
                                                 @input-file="inputFile"
                                                 ref="upload"
                                                 webkitdirectory mozdirectory>
                                                 <i class="icon icon-plus"></i>
                                                 Select
                                            </file-upload>
                                       </div>
                                  </div> -->
                                  <div class="d-flex flex-wrap align-items-center mt-4">
                                       <div class="col-lg-6 col-md-6 col-sm-12 pl-0" v-for="(attachment,index) in attachments" :key="index">
                                            <div class="d-flex align-items-center mt-6 file-bg">
                                                 <div class="d-flex align-items-center" style="width:90%">
                                                      <div>
                                                           <img src="/static/images/storage.svg" width="20">
                                                      <!-- <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                      <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                      <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                      <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                      <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                      <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                      <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                      <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                      <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                      <img v-else-if="attachment.name.endsWith('.mp3')" src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp3-icon.svg" style="width:40px; height:40px"/>
                                                      <img v-else-if="attachment.name.endsWith('.mp4')" src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp4-icon.svg" style="width:40px; height:40px"/>
                                                      <img v-else-if="attachment.name.endsWith('.MOV') || attachment.name.endsWith('.mov')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" style="width:40px; height:40px"/>
                                                      <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/> -->
                                                      <!-- <img v-else-if="attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')"  src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" style="width:40px; height:40px"/> -->
                                                      </div>
                                                      <div class="col">
                                                      <div class="d-flex justify-content-between">
                                                           <el-tooltip :content="attachment.name" placement="top">
                                                                <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                     {{attachment.name}}
                                                                </div>
                                                           </el-tooltip>
                                                      </div>
                                                      <div v-if="attachment.uploading || attachment.url == undefined">
                                                           <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                      </div>
                                                      <!-- <div class="d-flex justify-content-between">
                                                           <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                           <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                           <div class="fw-500" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                      </div> -->
                                                      </div>
                                                 </div>
                                                 <div class="pointer ml-3" style="width:10%" @click="deleteAttachment(attachment,index)">
                                                      <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                      <img src="/static/images/delete-bin-4-line.svg" width="20" alt="" v-if="attachment.url && attachment.uploading == false">
                                                      <!-- <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url && attachment.uploading == false"></i> -->
                                                 </div>
                                            </div>
                                       </div>
                                  </div>
                                  <modal
                                       transition="nice-modal-fade"
                                       class="new-modal-default emergency-contact-list"
                                       name="capture-image"
                                       v-if="show_capture_image"
                                       :delay="100"
                                       height="auto"
                                       :width="400"
                                       :adaptive="true" :scrollable="true"
                                  >
                                       <div class="v-modal-content" style="border-radius: 15px;background-color: #ebf3ff !important;">
                                            <div class="v-modal-body">
                                                 <div class="v-modal-layout d-flex justify-content-center">
                                                      <div id="app" class="web-camera-container mt-10">
                                                      <div v-show="isCameraOpen && isLoading" >
                                                           <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/>
                                                      </div>
                                                      <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                                                           <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                                                           <video v-show="!isPhotoTaken" ref="camera_capture" :width="250" :height="250" autoplay></video>
                                                           <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="250" :height="250"></canvas>
                                                      </div>
                                                      </div>
                                                 </div>
                                            </div>
                                            <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                                                 <a class="btn btn-danger btn-smm text-white" style="text-transform: uppercase !important;font-size: 12px !important;" @click="hideView()">CANCEL</a>
                                                 <button :disabled="!(isCameraOpen && !isLoading)" v-if="isCameraOpen && !isPhotoTaken" @click="takePhoto" type="button" class="btn btn-success btn-smm text-white ml-4" style="box-shadow: none;">
                                                      Capture
                                                 </button>
                                                 <button :disabled="!(isCameraOpen && !isLoading)" v-if="isPhotoTaken && isCameraOpen" @click="downloadImage" type="button" class="btn btn-success btn-smm text-white ml-4" style="box-shadow: none;">
                                                      Upload
                                                 </button>
                                            </div>
                                       </div>
                                  </modal>
                                  </div>
                             </div>
                             <div class="d-flex justify-content-end align-items-center my-8" v-if="$route.path.startsWith('/ticketdetails/view/') && can_approve && $route.query.part_status!='Approved'">
                                  <button class="btn btn-danger btn-custom-changes text-capitalize text-white" @click="showReject">Reject</button>
                                  <button class="btn btn-success btn-custom-changes text-capitalize text-white ml-5" @click="showApprove">Approve</button>
                             </div>
                             <div class="d-flex justify-content-end align-items-center my-8" v-else-if="$route.path.startsWith('/ticketdetails/view/') && !can_approve">
                                  <button class="btn btn-secondary text-white" @click="goToListView">Close</button>
                             </div>
                             <div class="d-flex justify-content-end mt-10 mb-3" v-if="generalActive && !$route.path.startsWith('/ticketdetails/view/') && can_edit">
                                  <button class="btn btn-danger-new mr-0" style="text-transform: uppercase !important;font-size: 12px !important;border-radius: 5px !important;" 
                                       @click="goToListView" :disabled="isUploadingInProgress || save_loader">
                                       Cancel
                                  </button>
                                  <button type="button" :disabled="isUploadingInProgress || save_loader" class="btn btn-green ml-3" :class="{'text-align-left': save_loader}" style="box-shadow: none;" @click="saveEdit">
                                       {{ template_type == 'multi_part' && is_approvers_mandatory ? 'Send for Review' : 'Save'}}
                                       <half-circle-spinner v-if='save_loader' :animation-duration="1000" :size="20" color="#00448b" style="top:-25px;left:40px" />
                                  </button>
                             </div>
                             <div class="d-flex justify-content-end mt-10 mb-3" v-if="generalActive && !$route.path.startsWith('/ticketdetails/view/') && can_close_ticket && is_approvers_mandatory">
                                  <button class="btn btn-danger-new mr-0" style="text-transform: uppercase !important;font-size: 12px !important;border-radius: 5px !important;" :disabled="isUploadingInProgress || save_loader" @click="goToListView">Cancel</button>
                                  <button type="button" :disabled="isUploadingInProgress || save_loader" class="btn btn-secondary-new text-white btn-smm ml-3" :class="{'text-align-left': save_loader}" style="box-shadow: none;" @click="closeTicket">
                                       Update
                                       <half-circle-spinner v-if='save_loader' :animation-duration="1000" :size="20" color="#00448b" style="top:-25px;left:47px" />
                                  </button>
                             </div>
                        </div>
                   </div>
              </div>
              <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
              <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
              <approve-ticket v-if="showapprove" :approval_data="approve_reject_prop_data" modal_name="ApproveTicket" @hideApprove="hideApprove" @hideApproveSaved="hideApproveSaved"></approve-ticket>
              <reject-ticket v-if="showreject" :rejection_data="approve_reject_prop_data" modal_name="RejectTicket" @hideReject="hideReject" @rejectApprovalSaved="rejectApprovalSaved"></reject-ticket>
              <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
              <view-log-attachments v-if="show_log_attachments" @hideLogAttachments="hideLogAttachments" @previewImage="previewImage" modal_name="ViewLogAttachments" :log_attachments="log_attachments"></view-log-attachments>
         </div>
   </div>
</template>

<script>
    import { HalfCircleSpinner } from "epic-spinners";
    import VueTagsInput from "@johmun/vue-tags-input";
    import ViewLogAttachments from "../Tickets/ViewLogAttachments.vue";
    import { VueEditor } from "vue2-editor";
    import scm from '../mixins/scm.js';
    import facility_mgmt from '../mixins/facility_mgmt';
    import time_utils from '../mixins/time_utils';
    import crm from '../mixins/crm.js';
    import ticket from '../mixins/ticket.js';
    import { SweetModal } from 'sweet-modal-vue';
    //import attachment from "../mixins/attachments.js";
    import FileUpload from 'vue-upload-component';
    // import SoftwareBugTemplate from "./SoftwareBugTemplate";
    import axios from 'axios';
    import {EventBus} from "../eventBus/nav-bar-event.js";
    import { debounce } from 'lodash';
    import ApproveTicket from '../Tickets/ApproveTicket'
    import RejectTicket from '../Tickets/RejectTicket.vue'
    import Preview from "../Preview.vue";
    var mime = require('mime-types')
    export default ({
         mixins: [ticket,scm,facility_mgmt,time_utils,crm],
         data() {
              return {
                   template_data: [],
                   entered_tag: '',
                   approvers_options: [],
                   tags_template: [],
                   isVisible: false,
                   template_search_key: '',
                   ticketName: '',
                   ticket_name_options: [],
                   model_name: '',
                   model_name_options: [],
                   model_number: 0,
                   radio_select: '',
                   date_of_purchase: '',
                   ticketTemplateListScrollable: false,
                   //   template_details: [],
                   ticket_details_description: '',
                   refund_reason: [],
                   time_of_purchase: '',
                   behalf:'myself',
                   department:'',
                   department_options:[],
                   descriptionlength:1000,
                   customer_options:[],
                   customer:'',
                   search_key:'',
                   customer_loading:false,
                   customer_count:0,
                   temp_customer_options:[],
                   customer_scrollable:false,
                   cutomer_visible:false,
                   viewMore:false,
                   authorized_person_id:'',
                   authorized_person_name:'',
                   authorized_department:'',
                   authorized_branch:'',
                   authorized_email:'',
                   authorized_phone:'',
                   ticket_template_type:'',
                   temp_assign_options:[],
                   assign_loading:false,
                   assign_scrollable:false,
                   assign_count:0,
                   assign_visible:false,
                   description:'',
                   showDescription:false,
                   is_parent_ticket:true,
                   parent_ticket_id:'',
                   ticket_type_loading:false,
                   is_validated:false,
                   auto_fill_data:{},
                   autoFilled:false,
                   max_due_date:'',
                   max_due_time:'',
                   api_date:'',
                   temp_attachments:[],
                   accept: '*',
                   extensions: '*',
                   size: 1024 * 1024 * 10,
                   total_file_size: 0,
                   multiple: true,
                   directory: true,
                   drop: true,
                   dropDirectory: true,
                   addIndex: false,
                   thread: 3,
                   name: 'file',
                   postAction: '/upload/post',
                   putAction: '/upload/put',
                   headers: {
                        'X-Csrf-Token': 'xxxx',
                   },
                   data: {
                        '_csrf_token': 'xxxxxx',
                   },
                   autoCompress: 1024 * 1024,
                   isOption: false,
                   parentTicketDetails:'',
                   nameOfTicket:'',
                   priority:'',
                   date_time_of_purchase:[],
                   due_date:'',
                   product_id:'',
                   machine_hours:[],
                   crm_customer_id:'',
                   branch_options:[],
                   branch_name:'',
                   productActive:false,
                   jobtypeActive:false,
                   tab_active1:true,
                   tab_active2:false,
                   job_ticket_template: '',
                   temp_branch_options:[],
                   branch_active: false,
                   customer_address:'',
                   job_type:'',
                   jobTypes:[],
                   sbr_active: false,
                   is_service_ticket: false,
                   branch_search: '',
                   is_input_data :false,
                   subject: "",
                   subjectlength:100,
                   ticketType:{
                        id: '',
                        name: ''
                   },
                   ticket_type_loading:false,
                   ticket_type_options: [],
                   ticket_type_count: 0,
                   assignedTo:'person',
                   assignedCustomer:'',
                   assign_loading: false,
                   assign_options: [],
                   assign_count: 0,
                   assign_scrollable: false,
                   temp_assign_options: [],
                   success_msg: '',
                   warning_msg: '',
                   description: '',
                   // template_details: [],
                   editTicketDetails: {
                        ticket_number: '',
                        status: '',
                        ticket_template: {
                             template_type: ''
                        }
                   },
                   editTicketTemplate: [],
                   generalActive:true,
                   ajaxCallinprogress: false,

                   // Upload and Attachments
                   temp_attachments: [],
                   attachments: [],
                   camera_selection: [],
                   selected_camera_device: '',
                   isPhotoTaken: false,
                   isShotPhoto: false,
                   isLoading: false,
                   isCameraOpen: false,
                   uploadAuto: false,
                   show_capture_image: false,
                   apicall_loading: false,
                   scm_products_options: [],
                   scm_products_count: 0,
                   isUploadingInProgress:false,
                   is_drop:false,
                   temp_location: {
                        address:"",
                        city:"",
                        country:"",
                        full_address:"",
                        location_vmodel:"",
                        state:"",
                        street1:"",
                        township:"",
                        zip_code:""
                   },
                   showapprove: false,
                   showreject: false,
                   can_edit: false,
                   template_type: '',
                   approvers_data: [],
                   is_approvers_mandatory: false,
                   can_approve: false,
                   approve_reject_prop_data: '',
                   pending_details: '',
                   can_edit_approver: false,
                   can_close_ticket: false,
                   preview_visible:false,
                   preview_file:{},
                   approvers_removable: false,
                   show_capture_image_multi: false,
                   location_loader: false,
                   save_loader: false,
                   show_log_attachments: false,
                   log_attachments: []
              }
         },
         components: {
              FileUpload,
              HalfCircleSpinner,
              ViewLogAttachments,
              VueTagsInput,
              VueEditor,
              SweetModal,
              ApproveTicket,
              RejectTicket,
              Preview
         },
         methods: {
              goTOBack(){
                   this.$router.go(-1)
              },
              handleInput() {
                   // Reset the image when the user types or deletes content
                   // this.imageUrl = '';
              },
              handlePasteMultiPart(event, field_index, index) {
                   // Access clipboard data
                   const clipboardData = event.clipboardData || window.clipboardData;
                   if(this.isUploadingInProgress) {
                        this.$toasted.global.error("Please wait. Previous file upload already in progress")
                   } else {
                        if (clipboardData) {
                             const items = clipboardData.items;

                             for (let i = 0; i < items.length; i++) {
                             const item = items[i];
                             // Check if the item is an image
                             if (item.type.indexOf('image') !== -1) {
                                  const blob = item.getAsFile();

                                  // Convert the blob to data URL
                                  const reader = new FileReader();
                                  reader.readAsDataURL(blob);
                                  reader.onload = (e) => {
                                  this.cropSuccessMultiPart(e.target.result, field_index, index)
                                  };
                             }
                             }
                        }
                   }
              },
              handlePasteByPart(event, field_index) {
                   // Access clipboard data
                   const clipboardData = event.clipboardData || window.clipboardData;
                   if(this.isUploadingInProgress) {
                        this.$toasted.global.error("Please wait. Previous file upload already in progress")
                   } else {
                        if (clipboardData) {
                             const items = clipboardData.items;

                             for (let i = 0; i < items.length; i++) {
                             const item = items[i];
                             // Check if the item is an image
                             if (item.type.indexOf('image') !== -1) {
                                  const blob = item.getAsFile();

                                  // Convert the blob to data URL
                                  const reader = new FileReader();
                                  reader.readAsDataURL(blob);
                                  reader.onload = (e) => {
                                  this.cropSuccessByPart(e.target.result, field_index)
                                  };
                             }
                             }
                        }
                   }
              },
              handlePasteDefaultField(event, index) {
                   // Access clipboard data
                   const clipboardData = event.clipboardData || window.clipboardData;
                   if(this.isUploadingInProgress) {
                        this.$toasted.global.error("Please wait. Previous file upload already in progress")
                   } else {
                        if (clipboardData) {
                             const items = clipboardData.items;

                             for (let i = 0; i < items.length; i++) {
                             const item = items[i];
                             // Check if the item is an image
                             if (item.type.indexOf('image') !== -1) {
                                  const blob = item.getAsFile();

                                  // Convert the blob to data URL
                                  const reader = new FileReader();
                                  reader.readAsDataURL(blob);
                                  reader.onload = (e) => {
                                  this.cropSuccessDefaultField(e.target.result, index)
                                  };
                             }
                             }
                        }
                   }
              },
              handlePasteDefaultAttachment(event) {
                   // Access clipboard data
                   const clipboardData = event.clipboardData || window.clipboardData;
                   if(this.isUploadingInProgress) {
                        this.$toasted.global.error("Please wait. Previous file upload already in progress")
                   } else {
                        if (clipboardData) {
                             const items = clipboardData.items;

                             for (let i = 0; i < items.length; i++) {
                             const item = items[i];
                             // Check if the item is an image
                             if (item.type.indexOf('image') !== -1) {
                                  const blob = item.getAsFile();

                                  // Convert the blob to data URL
                                  const reader = new FileReader();
                                  reader.readAsDataURL(blob);
                                  reader.onload = (e) => {
                                  this.cropSuccessDefaultAttachment(e.target.result)
                                  };
                             }
                             }
                        }
                   }
              },
              blobToFileClipboard(theBlob, fileName){
                   //A Blob() is almost a File() - it's just missing the two properties below which we will add
                   theBlob.lastModifiedDate = new Date();
                   theBlob.name = fileName;
                   const myFile = new File([theBlob], 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png', {
                        type: theBlob.type,
                   });
                   return myFile;
              },
              async cropSuccessMultiPart(imgData, part_index, field_index) {
                   const base64 = await fetch(imgData);
                   const blob = await base64.blob();
                   let file_data = this.blobToFileClipboard(blob, 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
                   // file_data  // file format type data of image
                   // this.uploadMPFieldAttachment(file_data, field_index, i)
                   let contains_duplicates = false
                   this.editTicketTemplate[part_index].parts_data[field_index].attachments.forEach((e) => {
                        if(e.name == file_data.name){
                             contains_duplicates = true
                        }
                   })
                   if(this.editTicketTemplate[part_index].parts_data[field_index].attachments.length < 10 && !contains_duplicates){
                        if (file_data) {
                             const CancelToken = axios.CancelToken;
                             const source = CancelToken.source();
                             let attachment = {
                             name: file_data.name,
                             size: JSON.stringify(file_data.size),
                             source: source,
                             progress: 0,
                             created_time: new Date(),
                             error: ""
                             }
                             this.editTicketTemplate[part_index].parts_data[field_index].attachments.push(attachment)
                             this.getResumableURLFieldAttachment(file_data, this.editTicketTemplate[part_index].parts_data[field_index].attachments[this.editTicketTemplate[part_index].parts_data[field_index].attachments.length - 1]);
                        }
                   } else if(contains_duplicates){
                        this.$toasted.global.error("This file is already uploaded")
                   } else {
                        this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                   }
              },
              async cropSuccessByPart(imgData, index) {
                   const base64 = await fetch(imgData);
                   const blob = await base64.blob();
                   let file_data = this.blobToFileClipboard(blob, 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
                   // file_data  // file format type data of image
                   // this.uploadAttachmentByPart(file_data, field_index)
                   let contains_duplicates = false
                   this.editTicketTemplate[index].attach_files.forEach((e) => {
                        if(e.name == file_data.name){
                             contains_duplicates = true
                        }
                   })
                   if(this.editTicketTemplate[index].attach_files.length < 10 && !contains_duplicates){
                        if (file_data) {
                             const CancelToken = axios.CancelToken;
                             const source = CancelToken.source();
                             let attachment = {
                             name: file_data.name,
                             size: JSON.stringify(file_data.size),
                             source: source,
                             progress: 0,
                             created_time: new Date(),
                             error: ""
                             }
                             this.editTicketTemplate[index].attach_files.push(attachment)
                             this.getResumableURLByPart(file_data, this.editTicketTemplate[index].attach_files[this.editTicketTemplate[index].attach_files.length - 1]);
                        }
                   } else if(contains_duplicates){
                        this.$toasted.global.error("This file is already uploaded")
                   } else {
                        this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                   }
              },
              async cropSuccessDefaultField(imgData, index) {
                   const base64 = await fetch(imgData);
                   const blob = await base64.blob();
                   let file_data = this.blobToFileClipboard(blob, 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
                   // file_data  // file format type data of image
                   // this.uploadDefaultFieldAttachment(file_data, index)
                   let contains_duplicates = false
                   this.editTicketTemplate[index].attachments.forEach((e) => {
                        if(e.name == file_data.name){
                             contains_duplicates = true
                        }
                   })
                   if(this.editTicketTemplate[index].attachments.length < 10 && !contains_duplicates){
                        if (file_data) {
                             const CancelToken = axios.CancelToken;
                             const source = CancelToken.source();
                             let attachment = {
                             name: file_data.name,
                             size: JSON.stringify(file_data.size),
                             source: source,
                             progress: 0,
                             created_time: new Date(),
                             error: ""
                             }
                             this.editTicketTemplate[index].attachments.push(attachment)
                             this.getResumableURLFieldAttachment(file_data, this.editTicketTemplate[index].attachments[this.editTicketTemplate[index].attachments.length - 1]);
                        }
                   } else if(contains_duplicates){
                        this.$toasted.global.error("This file is already uploaded")
                   } else {
                        this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                   }
              },
              async cropSuccessDefaultAttachment(imgData) {
                   const base64 = await fetch(imgData);
                   const blob = await base64.blob();
                   let file_data = this.blobToFileClipboard(blob, 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
                   // file_data  // file format type data of image
                   // this.uploadDefaultFieldAttachment(file_data, index)
                   let contains_duplicates = false
                   this.attachments.forEach((e) => {
                        if(e.name == file_data.name){
                             contains_duplicates = true
                        }
                   })
                   if(this.attachments.length < 10 && !contains_duplicates){
                        if (file_data) {
                             const CancelToken = axios.CancelToken;
                             const source = CancelToken.source();
                             let attachment = {
                             name: file_data.name,
                             size: JSON.stringify(file_data.size),
                             source: source,
                             progress: 0,
                             created_time: new Date(),
                             error: ""
                             }
                             this.attachments.push(attachment)
                             this.getResumableURLFieldAttachment(file_data, this.attachments[this.attachments.length - 1]);
                        }
                   } else if(contains_duplicates){
                        this.$toasted.global.error("This file is already uploaded")
                   } else {
                        this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                   }
              },
              viewLogAttachments(attachments){
                   this.log_attachments = attachments
                   this.show_log_attachments = true
                   setTimeout(() => {
                        this.$modal.show('ViewLogAttachments')
                   }, 500);
              },
              hideLogAttachments(){
                   this.show_log_attachments = false
              },
              HandleTimeEventMultiPart(event, part_index, indx, type){
                   if(type == 'date_time'){
                        if(event == ''){
                             this.editTicketTemplate[part_index].parts_data[indx].time = '12:00 am'
                        }
                   } else if(type == 'time'){
                        if(event == ''){
                             this.editTicketTemplate[part_index].parts_data[indx].answer = '12:00 am'
                        }
                   }
                   this.$forceUpdate()
              },
              HandleTimeEvent(event, indx, type){
                   if(type == 'date_time'){
                        if(event == ''){
                             this.editTicketTemplate[indx].time = '12:00 am'
                        }
                   } else if(type == 'time'){
                        if(event == ''){
                             this.editTicketTemplate[indx].answer = '12:00 am'
                        }
                   }
                   this.$forceUpdate()
              },
              previewImage(file) {
                    EventBus.$emit('ZindexChangeStart')
                   let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
                   file['content_type'] = content_type;
                   this.preview_file = file;
                   this.preview_visible = true;
              },
              hidePreview(){
                    EventBus.$emit('ZindexChangeEnd')
                   this.preview_visible = false
              },
              removeApprovers(option){
                   this.approvers_data.forEach((el,index)=>{
                        if(el == option){
                             this.approvers_data.splice(index,1)
                        }
                   })
              },
              showApprove(){
                   this.editTicketTemplate.forEach((x) => {
                        if(x.approval_status == 'pending'){
                             localStorage.setItem('pending_details', JSON.stringify(x))
                        }
                   })
                   let temp_pending_details = JSON.parse(localStorage.getItem('pending_details'))
                   delete temp_pending_details.approval_status
                   delete temp_pending_details.approval_details
                   delete temp_pending_details.show
                   delete temp_pending_details.attach_files
                   temp_pending_details['part_details'] = [...new Set(temp_pending_details.parts_data.map(x => x))]
                   delete temp_pending_details.parts_data
                   temp_pending_details.part_details.forEach((x, x_index) => {
                        if(x.type == 'tag'){
                             x.answer.forEach((ti, ti_index) => {
                                  delete ti['tiClasses']
                                  x.answer[ti_index] = ti.text
                             })
                             delete x.entered_tag
                        }
                        if(x.type == 'date_time'){
                             x.answer = x.date + ' ' + x.time
                             delete x.date
                             delete x.time
                        }
                        if(x.type == 'location'){
                             x.answer = x.location_details.location_vmodel
                             delete x.location_details
                             delete x.error
                        }
                        if(x.type == 'drop_down' && x.is_api_call_required == true){
                             x.product = x.answer['_id']
                             delete x.answer['category']
                             delete x.answer['description']
                             delete x.answer['item_code']
                             delete x.answer['sub_category']
                             delete x.answer['variant_id']
                             delete x.answer['_id']
                             delete x.answer['name']
                             x.answer = x.product
                             delete x.product
                        }
                        if(x.type == 'check_box' || x.type == 'radio_button' || x.type == 'drop_down'){
                             delete x['possible_values']
                             delete x.statement
                        }
                        delete x['is_api_call_required']
                        delete x['required']
                        delete x['type']
                        delete x['error']   
                   })
                   localStorage.removeItem('pending_details')
                   this.pending_details = temp_pending_details
                   //Initializing popup
                   this.approve_reject_prop_data = {
                        "ticket_id": this.$route.params.id,
                        "part_details": this.pending_details,
                        "action": {
                             "status": "approved",
                             "comment": "",
                             "attachments": []
                        }
                   }
                   this.showapprove = true
                   setTimeout(() => {
                        this.$modal.show('ApproveTicket')
                   }, 500);
              },
              showReject(){
                   this.editTicketTemplate.forEach((x) => {
                        if(x.approval_status == 'pending'){
                             localStorage.setItem('pending_details', JSON.stringify(x))
                        }
                   })
                   let temp_pending_details = JSON.parse(localStorage.getItem('pending_details'))
                   delete temp_pending_details.approval_status
                   delete temp_pending_details.approval_details
                   delete temp_pending_details.show
                   delete temp_pending_details.attach_files
                   temp_pending_details['part_details'] = [...new Set(temp_pending_details.parts_data.map(x => x))]
                   delete temp_pending_details.parts_data
                   temp_pending_details.part_details.forEach((x, x_index) => {
                        if(x.type == 'tag'){
                             x.answer.forEach((ti, ti_index) => {
                                  delete ti['tiClasses']
                                  x.answer[ti_index] = ti.text
                             })
                             delete x.entered_tag
                        }
                        if(x.type == 'date_time'){
                             x.answer = x.date + ' ' + x.time
                             delete x.date
                             delete x.time
                        }
                        if(x.type == 'location'){
                             x.answer = x.location_details.location_vmodel
                             delete x.location_details
                             delete x.error
                        }
                        if(x.type == 'drop_down' && x.is_api_call_required == true){
                             x.product = x.answer['_id']
                             delete x.answer['category']
                             delete x.answer['description']
                             delete x.answer['item_code']
                             delete x.answer['sub_category']
                             delete x.answer['variant_id']
                             delete x.answer['_id']
                             delete x.answer['name']
                             x.answer = x.product
                             delete x.product
                        }
                        if(x.type == 'check_box' || x.type == 'radio_button' || x.type == 'drop_down'){
                             delete x['possible_values']
                             delete x.statement
                        }
                        delete x['is_api_call_required']
                        delete x['required']
                        delete x['type']
                        delete x['error']   
                   })
                   localStorage.removeItem('pending_details')
                   this.pending_details = temp_pending_details
                   //Initializing popup
                   this.approve_reject_prop_data = {
                        "ticket_id": this.$route.params.id,
                        "part_details": this.pending_details,
                        "action": {
                             "status": "rejected",
                             "comment": "",
                             "attachments": []
                        }
                   }
                   this.showreject = true
                   setTimeout(() => {
                        this.$modal.show('RejectTicket')
                   }, 500);
              },
              hideApprove(){
                   this.showapprove = false
              },
              hideApproveSaved(){
                   this.getDetails()
                   this.showapprove = false
              },
              hideReject(){
                   this.showreject = false
              },
              rejectApprovalSaved(){
                   this.getDetails()
                   this.showreject = false
              },
              goToEditTicket(){
                   if(this.editTicketDetails.status == 'Fixed' && this.template_type == 'multi_part'){
                        EventBus.$emit("scrollToBottom")
                   }
                   this.$router.push({
                             path: `/ticketdetails/edit/${this.$route.params.id}`,
                             query: {
                                  type: 'normal_ticket'
                             }
                        }
                   )
              },
              tagsChangeData(update_tag, index, mode){
                   if(mode == 'by-field'){
                        this.editTicketTemplate[index].answer = update_tag
                   } else if(mode == 'by-function'){
                        this.editTicketTemplate[index].answer=update_tag
                        setTimeout(() => {
                             document.querySelector(".ti-tags").setAttribute("id", "fstprod");
                             document.getElementById("fstprod").firstChild.style.pointerEvents = 'none';
                             document.getElementById("fstprod").firstChild.lastChild.style.display = 'none';
                        }, 500);
                   }
                   this.$forceUpdate()
              },
              insertProductTag(answer){
                   this.editTicketTemplate.forEach((el, el_index) => {
                        if(el.type == "tag" && answer != ''){
                             let temp_ans = [...new Set(el.answer.map(x => x))];
                                  temp_ans.shift()
                                  temp_ans.unshift({
                                  text: answer.name,
                                  tiClasses: [
                                       "ti-valid"
                                  ]
                             })
                             this.tagsChangeData(temp_ans, el_index, 'by-function')
                        }
                   })
                   this.$forceUpdate()
              },
              insertMultiProductTag(answer){
                   this.editTicketTemplate.forEach((el, el_index) => {
                        el.parts_data.forEach((x, x_index) => {
                             if(el.type == "tag" && answer != ''){
                                  let temp_ans = [...new Set(el.answer.map(x => x))];
                                       temp_ans.shift()
                                       temp_ans.unshift({
                                       text: answer.name,
                                       tiClasses: [
                                            "ti-valid"
                                       ]
                                  })
                                  this.tagsChangeMultiData(temp_ans, x_index, el_index, 'by-function')
                             }
                        })
                   })
                   this.$forceUpdate()
              },
              tagsChangeMultiData(update_tag, part_index, index, mode){
                   if(mode == 'by-field'){
                        this.editTicketTemplate[part_index].parts_data[index].answer = update_tag
                   } else if(mode == 'by-function'){
                        this.editTicketTemplate[part_index].parts_data[index].answer = update_tag
                        setTimeout(() => {
                             document.querySelector(".ti-tags").setAttribute("id", "fstprod");
                             document.getElementById("fstprod").firstChild.style.pointerEvents = 'none';
                             document.getElementById("fstprod").firstChild.lastChild.style.display = 'none';
                        }, 500);
                   }
              },
              ToggleParts(part){
                   if(part.show){
                        part.show = false
                   } else {
                        part.show = true
                   }
                   this.$forceUpdate()
              },
              setPlace(place,index) {
                   let address = place.formatted_address.split(", ");
                   this.temp_location['street1'] =
                        address[address.length - 6] || "";
                   this.temp_location['township'] =
                        address[address.length - 4] || "";
                   this.temp_location['city'] = address[address.length - 3] || "";
                   let statezip = address[address.length - 2]
                        ? address[address.length - 2].split(" ")
                        : ["", ""];
                   if (statezip.length == 1) {
                        if (statezip[0].match(/^[0-9]+$/)) {
                        this.temp_location['zip_code'] = statezip[0];
                        } else {
                        this.temp_location['state'] = statezip[0];
                        }
                   } else {
                        this.temp_location['zip_code'] = statezip[0].match(/^[0-9]+$/)
                        ? statezip[0]
                        : statezip[1].match(/^[0-9]+$/)
                        ? statezip[1]
                        : "";
                        this.temp_location['state'] = statezip[0].match(/^[a-zA-Z]+$/)
                        ? statezip[0]
                        : statezip[1].match(/^[a-zA-Z]+$/)
                        ? statezip[1]
                        : "";
                   }
                   if (address[address.length - 1].includes("-")) {
                        let countrySelected = address[address.length - 1].split(" - ");
                        countrySelected.forEach(x => {
                        if (this.countries.includes(x)) {
                             this.temp_location['country'] = x;
                        } else {
                             this.temp_location['country'] = "";
                        }
                        });
                   } else {
                        this.temp_location['country'] = address[address.length - 1];
                   }
                   // this.facility_address.address.latitude = currentPlace.geometry.location.lat() || "";
                   // this.facility_address.address.longitude = currentPlace.geometry.location.lng() || "";
                   this.temp_location['location_vmodel'] = place.formatted_address;
                   this.temp_location['full_address'] = place.formatted_address;
                   this.editTicketTemplate[index].location_details = this.temp_location
                   this.$forceUpdate();
              },
              getLocation(index) {
                   // this.addressIndex = index;
                   if (navigator.geolocation) {
                        this.location_loader = true
                        // timeout at 60000 milliseconds (60 seconds)
                        var options = {
                             enableHighAccuracy: false,
                             timeout: 30000, // milliseconds (30 seconds)
                             maximumAge: 600000
                        }; // milliseconds (10 minutes)
                        navigator.geolocation.getCurrentPosition(
                             this.showLocation,
                             this.errorHandler,
                             this.assignLocationDetails(index),
                             options
                        );
                   } else {
                        alert("Sorry, browser does not support geolocation!");
                   }
                   document.getElementById('DisableOnClick' + index).style.pointerEvents = 'none';
              },
              getMultiPartLocation(part_index, field_index){
                   if (navigator.geolocation) {
                        this.location_loader = true
                        // timeout at 60000 milliseconds (60 seconds)
                        var options = {
                             enableHighAccuracy: false,
                             timeout: 30000, // milliseconds (30 seconds)
                             maximumAge: 600000
                        }; // milliseconds (10 minutes)
                        navigator.geolocation.getCurrentPosition(
                             this.showLocation,
                             this.errorHandler,
                             this.assignMultiLocationDetails(part_index, field_index),
                             options
                        );
                   } else {
                        alert("Sorry, browser does not support geolocation!");
                   }
                   document.getElementById('DisableOnClick' + field_index + part_index).style.pointerEvents = 'none';
              },
              assignLocationDetails(index){
                   this.editTicketTemplate[index].location_details = this.temp_location
              },
              assignMultiLocationDetails(part_index, field_index){
                   this.editTicketTemplate[part_index].parts_data[field_index].location_details = this.temp_location
              },
              showLocation(position) {
                   this.latitude = position.coords.latitude;
                   this.longitude = position.coords.longitude;
                   let latlongvalue = position.coords.latitude + "," + position.coords.longitude;
                   let calllatlong = axios.create();
                   delete calllatlong.defaults.headers.common['Authorization'];
                   calllatlong.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + latlongvalue + "&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY")
                   .then(response => {
                        let address = response.data.results[0].formatted_address.split(", ");
                        this.temp_location['street1'] =
                        address[address.length - 6] || "";
                        this.temp_location['township'] =
                        address[address.length - 4] || "";
                        this.temp_location['city'] = address[address.length - 3] || "";
                        let statezip = address[address.length - 2]
                        ? address[address.length - 2].split(" ")
                        : ["", ""];
                        this.temp_location['zip_code'] = statezip[0].match(/^[0-9]+$/)
                        ? statezip[0]
                        : statezip[1].match(/^[0-9]+$/)
                        ? statezip[1]
                        : "";
                        this.temp_location['state'] = statezip[0].match(/^[a-zA-Z]+$/)
                        ? statezip[0]
                        : statezip[1].match(/^[a-zA-Z]+$/)
                        ? statezip[1]
                        : "";
                        if (address[address.length - 1].includes("-")) {
                        let countrySelected = address[address.length - 1].split(" - ");
                        countrySelected.forEach(x => {
                             if (this.countries.includes(x)) {
                             this.temp_location['country'] = x;
                             } else {
                             this.temp_location['country'] = "";
                             }
                        });
                        } else {
                        this.temp_location['country'] = address[address.length - 1];
                        }
                        this.temp_location['location_vmodel'] = response.data.results[0].formatted_address;
                        this.temp_location['full_address'] = response.data.results[0].formatted_address;
                        this.location_loader = false
                        this.$forceUpdate();
                   })
                   .catch(e => {
                        // this.errors.push(e)
                   });
              },
              errorHandler(err) {
                   if (err.code == 1) {
                        alert("Please Allow Location Access");
                   } else if (err.code == 2) {
                        alert("Error: Position is unavailable!");
                   }
              },
              updateValue(newTags) {
                   this.$emit('updateTags', newTags);
              },
              hideView() {
                   this.toggleCamera();
              },
              hideViewMultiPart(index){
                   this.toggleCameraMultiPart(index);
              },
              goToListView() {
                   if(this.$route.query.type == 'review_ticket'){
                        this.$router.push({
                             path: "/ticketdetails?view_ticket=review",
                             query: {
                                  view_ticket: 'review'
                             }
                        })
                   } else {
                        // if(this.template_type == 'multi_part' && this.$route.path.startsWith('/ticketdetails/edit/') && this.is_approvers_mandatory){
                        //      EventBus.$emit('scrollToTop')
                        //      this.$router.push(`/ticketdetails/view/${this.$route.params.id}`)
                        // } else {
                             if(this.$route.query.hasOwnProperty('from_filtered_status')){
                                  this.$router.push({ 
                                       path: "/ticketdetails",
                                       query: {
                                            view_ticket: this.$route.query.from_filtered_status
                                       }
                                  })  
                             } else {
                                  this.$router.push({ 
                                       path: "/ticketdetails"
                                  }) 
                             }
                        // }   
                   }
              },
              async getNextMultiPart(part){
                   try{
                        let params = {
                             "part_name": part.part_name,
                             "ticket_id": this.$route.params.id
                        }
                        let response = await this.getNextPart(params)
                        let temp_pending_detail = response.response.next_part_details
                        this.editTicketTemplate.forEach((x) => {
                             if(x.part_name == temp_pending_detail.part_name){
                                  x.attach_files = []
                                  x.parts_data = temp_pending_detail.part_data
                                  x.approval_status = 'pending'
                                  x.show = true
                                  x.parts_data.forEach((y) => {
                                       if(y.type == 'check_box'){
                                            y.answer = []
                                       } else if(y.type == 'radio_button' || y.type == 'drop_down') {
                                            y.answer = ''
                                       } else if(y.type == 'short_answer' || y.type == 'long_answer'){
                                            y.answer = ''
                                       } else if((y.type == 'tag' && this.editTicketDetails.ticket_template.name == 'Product Bug Template') || (y.type == 'tag' && this.editTicketDetails.ticket_template.name == 'Digicollect Product Template')){
                                            let tag_data1 = [...new Set(this.editTicketTemplate[index].answer.map(x => x))];
                                            tag_data1.forEach((e, e_index) => {
                                                 if(this.editTicketTemplate[0].answer.name == e){
                                                      tag_data1.unshift(e)
                                                      tag_data1.splice(e_index+1,1)
                                                 }
                                            })
                                            tag_data1.forEach((el, el_index) => {
                                                 if(el_index == 0){
                                                      this.editTicketTemplate[index].answer[el_index] = {
                                                           text: el,
                                                           tiClasses: {}
                                                      }
                                                 }else {
                                                      this.editTicketTemplate[index].answer[el_index] = {
                                                           text: el,
                                                           tiClasses: {}
                                                      }
                                                 }
                                                 setTimeout(() => {
                                                      document.querySelector(".ti-tags").setAttribute("id", "fstprod");
                                                      document.getElementById("fstprod").firstChild.style.pointerEvents = 'none';
                                                      document.getElementById("fstprod").firstChild.lastChild.style.display = 'none';
                                                 }, 500);
                                            })
                                       }
                                       else if((y.type == 'tag' && this.editTicketDetails.ticket_template.name != 'Product Bug Template') || (y.type == 'tag' && this.editTicketDetails.ticket_template.name != 'Digicollect Product Template')){
                                            y.entered_tag = ''
                                            y.answer = []
                                            y.answer.forEach((ti, ti_index) => {
                                                 y.answer[ti_index] = {text: y.answer[ti_index], tiClasses: {}}
                                            })
                                       }
                                       else if(y.type=="date_time"){
                                            y['date'] = '';
                                            y['time'] = '';
                                       }
                                       else if(y.type=="date" || y.type=="time"){
                                            y['answer'] = '';
                                       }
                                       else if(y.type == 'location'){
                                            y.location_details = {
                                                 address:"",
                                                 city:"",
                                                 country:"",
                                                 full_address:x.answer,
                                                 location_vmodel:'',
                                                 state:"",
                                                 street1:"",
                                                 township:"",
                                                 zip_code:""
                                            }
                                       }
                                       if(y.hasOwnProperty('add_attachments') && y.add_attachments){
                                            y.attachments = []
                                            y.attachment_error = false
                                       }
                                  })
                             }
                        })
                   } catch(err){
                        console.log(err)
                   }
              },
              async getDetails(){
                   this.editTicketTemplate = []
                   this.ajaxCallinprogress = true
                   if(this.$route.query.type == 'review_ticket'){
                        var res = await this.ViewReviewTicket(
                             {
                                  ticket_id: this.$route.params.id, 
                                  part_name: this.$route.query.part_name
                             }
                        )
                   } else {
                        var res = await this.getTicketById({"ticket_id": this.$route.params.id});
                   }
                   this.can_edit = res.response.can_edit
                   this.editTicketDetails = res.response.general_details
                   // Ticket Details
                   this.subject = this.editTicketDetails.subject;
                   this.ticketType =this.editTicketDetails.ticket_template;
                   this.template_type = this.editTicketDetails.ticket_template.template_type
                   if(this.editTicketDetails.assigned_to == ''){
                        this.assignedTo = 'unassigned'
                   } else {
                        this.assignedTo = 'person'
                   }
                   this.assignedCustomer = {
                        department:"",
                        email_id:"",
                        id:this.editTicketDetails.assigned_to_id,
                        name:this.editTicketDetails.assigned_to
                   };
                   this.description = this.editTicketDetails.description;
                   this.attachments = this.editTicketDetails.attach_files
                   this.attachments.forEach((el, el_index) => {
                        el.uploading = false
                   })
                   if(this.editTicketDetails.approve_data.length > 0){
                        this.is_approvers_mandatory = true
                   } else {
                        this.is_approvers_mandatory = false
                   }
                   // Template Details
                   if(this.template_type == 'default'){
                        this.editTicketTemplate = res.response.template_data[this.ticketType.name];
                        this.editTicketTemplate.forEach((el, index) => {
                             if(el.type=="date_time"){
                                  el['date'] = el.answer.slice(0,10);
                                  el['time'] = el.answer.slice(11, );
                             }
                             if(el.type == 'location'){
                                  el.location_details = {
                                       address:"",
                                       city:"",
                                       country:"",
                                       full_address:el.answer,
                                       location_vmodel:el.answer,
                                       state:"",
                                       street1:"",
                                       township:"",
                                       zip_code:""
                                  }
                             }
                             el.error = false
                        })
                   } else {
                        this.approvers_data = this.editTicketDetails.approve_data
                        if(this.$route.query.type != 'review_ticket'){
                             this.approvers_options = res.response.total_approves_list
                        }
                        if(this.is_approvers_mandatory){
                             this.can_approve = res.response.action || false
                             this.can_close_ticket = res.response.can_save
                             if(res.response.approved_part_details.length == 0){
                                  this.can_edit_approver = true
                             } else {
                                  this.can_edit_approver = false
                             }
                             res.response.approved_part_details.forEach((e, e_index) => {
                                  if(e.hasOwnProperty('part_data')){
                                       e.parts_data = JSON.parse(JSON.stringify(e.part_data))
                                       delete e.part_data
                                  }
                                  e.approval_status = 'approved'
                             })
                             res.response.approved_part_details.forEach((e, e_index) => {
                                  this.editTicketTemplate.push(e)
                             })
                             res.response.pending_details.forEach((e, e_index) => {
                                  if(e.hasOwnProperty('part_data')){
                                       e.parts_data = JSON.parse(JSON.stringify(e.part_data))
                                       delete e.part_data
                                  }
                                  e.approval_status = 'pending'
                             })
                             res.response.pending_details.forEach((e, e_index) => {
                                  this.editTicketTemplate.push(e)
                             })
                             res.response.remaining_parts.forEach((e, e_index) => {
                                  if(e.hasOwnProperty('part_data')){
                                       e.parts_data = JSON.parse(JSON.stringify(e.part_data))
                                       delete e.part_data
                                  }
                                  e.approval_status = 'upcoming'
                             })
                             res.response.remaining_parts.forEach((e, e_index) => {
                                  this.editTicketTemplate.push(e)
                             })
                             if(res.response.pending_details.length == 0){
                                  if(res.response.remaining_parts.length != 0){
                                       setTimeout(() => {
                                            this.getNextMultiPart(res.response.remaining_parts[0])
                                       }, 500);
                                  }
                             }
                             if(res.response.approved_part_details.length > 0){
                                  this.approvers_removable = false
                             } else {
                                  this.approvers_removable = true
                             }
                        } else {
                             res.response.template_data.forEach((e, e_index) => {
                                  if(e.hasOwnProperty('part_data')){
                                       e.parts_data = JSON.parse(JSON.stringify(e.part_data))
                                       delete e.part_data
                                  }
                                  e.approval_status = 'pending'
                             })
                             res.response.template_data.forEach((e, e_index) => {
                                  this.editTicketTemplate.push(e)
                             })
                        }
                   }
                   this.getTemplateSpace();
                   this.ajaxCallinprogress = false
              },
              getTemplateSpace(){
                   if(this.template_type == 'default'){
                        this.editTicketTemplate.forEach((data,index) => {
                             if(data.type == 'check_box' || data.type == 'radio_button') {
                                  this.editTicketTemplate[index].answer = this.editTicketTemplate[index].answer
                             }
                             else if((data.type == 'tag' && this.editTicketDetails.ticket_template.name != 'Digicollect Product Template') && (data.type == 'tag' && this.editTicketDetails.ticket_template.name != 'Product Bug Template')){
                                  this.editTicketTemplate[index].entered_tag = ''
                                  this.editTicketTemplate[index].answer.forEach((ti, ti_index) => {
                                       this.editTicketTemplate[index].answer[ti_index] = {text: this.editTicketTemplate[index].answer[ti_index], tiClasses: {}}
                                  })
                             } else if((data.type == 'tag' && this.editTicketDetails.ticket_template.name == 'Product Bug Template') || (data.type == 'tag' && this.editTicketDetails.ticket_template.name == 'Digicollect Product Template')){
                                  let tag_data1 = [...new Set(this.editTicketTemplate[index].answer.map(x => x))];
                                  tag_data1.forEach((e, e_index) => {
                                       if(this.editTicketTemplate[0].answer.name == e){
                                            tag_data1.unshift(e)
                                            tag_data1.splice(e_index+1,1)
                                       }
                                  })
                                  tag_data1.forEach((el, el_index) => {
                                       if(el_index == 0){
                                            this.editTicketTemplate[index].answer[el_index] = {
                                                 text: el,
                                                 tiClasses: {}
                                            }
                                       }else {
                                            this.editTicketTemplate[index].answer[el_index] = {
                                                 text: el,
                                                 tiClasses: {}
                                            }
                                       }
                                       setTimeout(() => {
                                            document.querySelector(".ti-tags").setAttribute("id", "fstprod");
                                            document.getElementById("fstprod").firstChild.style.pointerEvents = 'none';
                                            document.getElementById("fstprod").firstChild.lastChild.style.display = 'none';
                                       }, 500);
                                  })
                             }
                             else {
                                  this.editTicketTemplate[index].answer = this.editTicketTemplate[index].answer
                             }
                             if(data.type == 'drop_down' && !data.is_api_call_required && (!data.hasOwnProperty('answer') || data.answer == undefined )){
                                  data.answer = ''
                             }
                             // if(data.add_attachments){
                             //      data['attachments'] = []
                             //     data['attachment_error'] = false
                             // }
                             // if(data.hasOwnProperty('add_attachments') && data.add_attachments){
                             //   if(data.attachments.url == ''){
                             //        data.attachments = {
                             //             name: '',
                             //             url: '',
                             //        }
                             //   }
                             //   data['attachment_error'] = false
                             // }
                             if(data.add_attachments){
                                  if(data.hasOwnProperty('attachments')){
                                       data['attachments'] = data.attachments
                                       data['attachment_error'] = false
                                  } else {
                                       data['attachments'] = []
                                       data['attachment_error'] = false
                                  }
                             }
                        })    
                   } else {
                        this.editTicketTemplate.forEach((data,index) => {
                             data.show = true
                             data.parts_data.forEach((x, x_index) => {
                                  if(x.hasOwnProperty('attach_files')){
                                       x.attach_files = []
                                  }
                                  if(x.type == 'check_box' || x.type == 'radio_button') {
                                       x.answer = x.answer
                                  }
                                  // else if((x.type == 'tag' && this.editTicketDetails.ticket_template.name != 'Digicollect Product Template') && (x.type == 'tag' && this.editTicketDetails.ticket_template.name != 'Product Bug Template')){
                                  //      this.editTicketTemplate[index].entered_tag = ''
                                  //      this.editTicketTemplate[index].answer.forEach((ti, ti_index) => {
                                  //           this.editTicketTemplate[index].answer[ti_index] = {text: this.editTicketTemplate[index].answer[ti_index], tiClasses: {}}
                                  //      })
                                  // }
                                  else if((x.type == 'tag' && this.editTicketDetails.ticket_template.name == 'Product Bug Template') || (x.type == 'tag' && this.editTicketDetails.ticket_template.name == 'Digicollect Product Template')){
                                       let tag_data1 = [...new Set(this.editTicketTemplate[index].answer.map(x => x))];
                                       tag_data1.forEach((e, e_index) => {
                                            if(this.editTicketTemplate[0].answer.name == e){
                                                 tag_data1.unshift(e)
                                                 tag_data1.splice(e_index+1,1)
                                            }
                                       })
                                       tag_data1.forEach((el, el_index) => {
                                            if(el_index == 0){
                                                 this.editTicketTemplate[index].answer[el_index] = {
                                                      text: el,
                                                      tiClasses: {}
                                                 }
                                            }else {
                                                 this.editTicketTemplate[index].answer[el_index] = {
                                                      text: el,
                                                      tiClasses: {}
                                                 }
                                            }
                                            setTimeout(() => {
                                                 document.querySelector(".ti-tags").setAttribute("id", "fstprod");
                                                 document.getElementById("fstprod").firstChild.style.pointerEvents = 'none';
                                                 document.getElementById("fstprod").firstChild.lastChild.style.display = 'none';
                                            }, 500);
                                       })
                                  }
                                  else if(x.type=="date_time"){
                                       x['date'] = x.answer.slice(0,10);
                                       x['time'] = x.answer.slice(11, );
                                  }
                                  else if(x.type == 'location'){
                                       x.location_details = {
                                            address:"",
                                            city:"",
                                            country:"",
                                            full_address:x.answer,
                                            location_vmodel:x.answer,
                                            state:"",
                                            street1:"",
                                            township:"",
                                            zip_code:""
                                       }
                                  } 
                                  if(x.add_attachments){
                                       if(x.hasOwnProperty('attachments')){
                                            x['attachments'] = x.attachments
                                            x['attachment_error'] = false
                                       } else {
                                            x['attachments'] = []
                                            x['attachment_error'] = false
                                       }
                                  }
                                  // else {
                                  //      this.editTicketTemplate[index].answer = this.editTicketTemplate[index].answer
                                  // }
                                  x.error = false
                             })
                             if(data.hasOwnProperty('attach_files')){
                                  data.attach_files.forEach((y) => {
                                       y.uploading = false
                                  })
                             }
                        })
                        if(this.editTicketDetails.status == 'Fixed' && this.template_type == 'multi_part' && this.is_approvers_mandatory){
                             EventBus.$emit("scrollToBottom")
                        }
                   }
              },
              async getApiDD(){
                   this.apicall_loading = true
                   try{
                        let params = {
                             limit: 10,
                             search_key: "",
                             skip: 0
                        }
                        let response = await this.getScmProductsDD(params)
                        this.scm_products_options = response.response.products
                        this.scm_products_count = response.response.products.length
                        this.apicall_loading = false
                   } catch (error) {
                   }
              },
              async getTemplateApiDD(){
                   this.apicall_loading = true
                   try{
                        let params = {
                             limit: 10,
                             search_key: "",
                             skip: 0
                        }
                        let response = await this.getProductTemplatesDD(params)
                        this.scm_products_options = response.response.products
                        this.scm_products_count = response.response.products.length
                        this.apicall_loading = false
                   } catch (error) {
                   }
              },
              async searchTemplateApiDDDebouncer(search_key){
                   this.apicall_loading = true
                   // this.template_search_key = search_key || '';
                   try{
                        let params = {
                             limit: 10,
                             search_key: search_key,
                             skip: 0
                        }
                        let response = await this.getProductTemplatesDD(params)
                        this.scm_products_options = response.response.products
                        this.scm_products_count = response.response.products.length
                        this.apicall_loading = false
                   } catch (error) {
                   }
              },
              async searchApiDDDebouncer(search_key){
                   this.apicall_loading = true
                   // this.template_search_key = search_key || '';
                   try{
                        let params = {
                             limit: 10,
                             search_key: search_key,
                             skip: 0
                        }
                        let response = await this.getScmProductsDD(params)
                        this.scm_products_options = response.response.products
                        this.scm_products_count = response.response.products.length
                        this.apicall_loading = false
                   }
                   catch (error) {
                   }
              },
              async getTicketTemplate(){
                   this.ticket_type_loading = true
                   try {
                        let params = {
                             limit: 10,
                             search_key: '',
                             skip: 0,
                             sort_key: 'name',
                             sort_value: 1
                        }
                        let response = await this.getDynamicTemplateList(params)
                        this.ticket_type_options = response.response.dynamic_details
                        this.ticket_type_count = response.response.dynamic_details.length
                        this.ticket_type_loading = false
                   } catch (error) {
                   }
              },
              async searchTemplate(search_key){
                   this.ticket_type_loading = true
                   this.template_search_key = search_key || '';
                   try{
                        let params = {
                             skip: 0,
                             limit: 10,
                             search_key: this.template_search_key,
                             sort_key: 'name',
                             sort_value: 1
                        }
                        let response = await this.getDynamicTemplateList(params)
                        this.ticket_type_options = response.response.dynamic_details
                        this.ticket_type_count = response.response.dynamic_details.length
                        this.ticket_type_loading = false
                   } catch (error) {
                   }
              },
              async getAllAssignToDebouncer(search_key){
                   try {
                        this.assign_options = []
                        this.assign_loading = true
                        let params ={
                             skip:0,
                             limit:10,
                             search_key:search_key
                        }
                        let res = await this.getUserForTickets(params)
                        this.assign_options = res.response.assigned_user_details
                        this.assign_count = this.temp_assign_options.length
                        this.assign_loading = false
                        this.assign_scrollable = false
                   } catch (reason) {

                   }
              },
              async reachedEndOfAssigned(reached){
                   this.assign_visible = reached
                   if (reached) {
                        if (this.assign_scrollable == false) {
                             this.assign_loading = true
                             let params ={
                             skip:this.assign_count,
                             limit:10,
                             search_key:this.search_key
                             }
                             let response = await this.getUserForTickets(params)
                             this.temp_assign_options = response.response.assigned_user_details.length;
                             if (response.response.skip == this.assign_count) {
                             if (this.temp_assign_options > 0) {
                                  let tempFiles = response.response.assigned_user_details;
                                  tempFiles.forEach(el => {
                                       this.assign_options.push(el);
                                  });
                                  this.assign_count += response.response.assigned_user_details.length;
                                  this.assign_loading = false
                             } else {
                                  this.assign_scrollable = true
                                  this.assign_loading = false
                             }
                             }
                             this.assign_loading = false
                        }
                   }
              },
              async closeTicket(){
                   let payload = {
                        ticket_id: this.$route.params.id
                   }
                   this.CloseMultiPartTicket(payload).then(response => {
                        this.success_msg = response.response
                        this.$refs.success_modal.open();
                        setTimeout(() => {
                             this.$refs.success_modal.close();
                             this.$router.push('/ticketdetails/'+this.$route.params.id)
                             this.getDetails()
                        }, 3000);
                   }).catch((err) => {
                        this.warning_msg = err;
                        this.$refs.warning_modal.open();
                        setTimeout(() => this.$refs.warning_modal.close(), 2000);
                   })
              },
              saveEdit(){
                   var check_attachments_error_mp=[]
                   if(this.template_type == 'default'){
                        this.editTicketTemplate.forEach((template, template_index) => {
                             if(template.type == 'location' && template.required == true && template.location_details.location_vmodel == ''){
                                  template.error = true
                             } else {
                                  template.error = false
                             }
                             if(template.required == true && template.add_attachments && template.attachments.length <= 0){
                                  check_attachments_error_mp.push(true)
                                  template.attachment_error = true
                             } else {
                                  check_attachments_error_mp.push(false)
                                  template.attachment_error = false
                             }
                        })
                   }
                   if(this.template_type == 'multi_part'){
                        this.editTicketTemplate.forEach((template, template_index) => {
                             template.parts_data.forEach((x, i) => {
                                  if(x.required == true && x.add_attachments && x.attachments.length <= 0){
                                       check_attachments_error_mp.push(true)
                                       x.attachment_error = true
                                  } else {
                                       check_attachments_error_mp.push(false)
                                       x.attachment_error = false
                                  }
                                  // Location
                                  if(this.is_approvers_mandatory){
                                       if(x.type == 'location' && x.required == true && x.location_details.location_vmodel == '' && template.approval_status == 'pending'){
                                            check_attachments_error_mp.push(true)
                                            x.error = true
                                       } else {
                                            check_attachments_error_mp.push(false)
                                            x.error = false
                                       }
                                  } else {
                                       if(x.type == 'location' && x.required == true && x.location_details.location_vmodel == ''){
                                            check_attachments_error_mp.push(true)
                                            x.error = true
                                       } else {
                                            check_attachments_error_mp.push(false)
                                            x.error = false
                                       }
                                  }
                             })
                        })
                   }
                   this.$validator.validateAll().then(result => {
                        // && this.attachments.length <= 10 && this.editTicketTemplate.every(this.checkError)
                        if (result == true){
                             this.attachments.forEach(attachment => {
                                  delete attachment['created_time']
                                  delete attachment['error']
                                  delete attachment['id'];
                                  delete attachment['progress']
                                  // delete attachment['size']
                                  delete attachment['uploading']
                             })
                             localStorage.setItem("ticketDetailsEdit", JSON.stringify(this.create_json));
                             let created_data = JSON.parse(localStorage.getItem('ticketDetailsEdit'));
                             if(this.template_type == 'default' && this.editTicketTemplate.every(this.checkError) && this.editTicketTemplate.every(x => x.attachment_error == false)){
                                  created_data.template_data.forEach((template, index) => {
                                       if(template.type == 'tag'){
                                            template.answer.forEach((ti, ti_index) => {
                                                 delete ti['tiClasses']
                                                 template.answer[ti_index] = ti.text
                                            })
                                            delete template.entered_tag
                                       }
                                       if(template.type == 'date_time'){
                                            template.answer = template.date + ' ' + template.time
                                            delete template.date
                                            delete template.time
                                       }
                                       if(template.type == 'location'){
                                            template.answer = template.location_details.location_vmodel
                                            delete template.location_details
                                            delete template.error
                                       }
                                       if(template.type == 'drop_down' && template.is_api_call_required == true){
                                            template.product = template.answer['_id']
                                            delete template.answer['category']
                                            delete template.answer['description']
                                            delete template.answer['item_code']
                                            delete template.answer['sub_category']
                                            delete template.answer['variant_id']
                                            delete template.answer['_id']
                                            delete template.answer['name']
                                            template.answer = template.product
                                            delete template.product
                                       }
                                       if(template.type == 'check_box' || template.type == 'radio_button' || template.type == 'drop_down'){
                                            delete template['possible_values']
                                            if(template.hasOwnProperty('statement')){
                                                 delete template.statement
                                            }
                                       }
                                       if(template.hasOwnProperty('attachments') && template.attachments.url != ''){
                                            delete template.attachments['created_time']
                                            delete template.attachments['error']
                                            delete template.attachments['progress']
                                            delete template.attachments['uploading']
                                            // delete x.attachments['size']
                                       }
                                       if(template.add_attachments && template.hasOwnProperty('attachments')){
                                            template.attachments.forEach((e) => {
                                                 delete e['created_time']
                                                 delete e['error']
                                                 delete e['progress']
                                                 // delete e['size']
                                                 delete e['uploading']
                                            })
                                       }
                                       delete template['add_attachments']
                                       delete template['attachment_error']
                                       delete template['is_api_call_required']
                                       delete template['required']
                                       delete template['type']
                                       delete template['error']
                                  })
                                  created_data.attach_files = this.attachments
                                  try{
                                       this.editNewTicket(created_data)
                                  } catch(error) {
                                  }
                             } else if(this.template_type == 'multi_part' && check_attachments_error_mp.every(x => x == false)){
                                  let temp_template_data = []
                                  if(this.approvers_data.length > 0 && this.can_edit_approver){
                                       created_data.approvers_list = this.approvers_data.map(x => x.id)
                                  }
                                  delete created_data.assignment_details
                                  created_data.template_data.forEach((template, index) => {
                                       if(template.approval_status == 'pending'){
                                            temp_template_data.push(template)
                                       }
                                       delete template.approval_status
                                       delete template.approval_details
                                  })
                                  created_data.template_data = JSON.parse(JSON.stringify(temp_template_data))
                                  created_data.template_data.forEach((template, index) => {
                                       template.is_send_for_review = this.is_approvers_mandatory
                                       template.parts_data.forEach((x, x_index) => {
                                            if(x.type == 'tag'){
                                                 x.answer.forEach((ti, ti_index) => {
                                                      if(ti.hasOwnProperty('text')){
                                                           x.answer[ti_index] = ti.text
                                                      }
                                                      if(ti.hasOwnProperty('tiClasses')){
                                                           delete ti['tiClasses']
                                                      }
                                                 })
                                                 if(x.hasOwnProperty('entered_tag')){
                                                      delete x.entered_tag
                                                 }
                                            }
                                            if(x.type == 'date_time'){
                                                 x.answer = x.date + ' ' + x.time
                                                 delete x.date
                                                 delete x.time
                                            }
                                            if(x.type == 'location'){
                                                 x.answer = x.location_details.location_vmodel
                                                 delete x.location_details
                                                 delete x.error
                                            }
                                            if(x.type == 'drop_down' && x.is_api_call_required == true){
                                                 x.product = x.answer['_id']
                                                 delete x.answer['category']
                                                 delete x.answer['description']
                                                 delete x.answer['item_code']
                                                 delete x.answer['sub_category']
                                                 delete x.answer['variant_id']
                                                 delete x.answer['_id']
                                                 delete x.answer['name']
                                                 x.answer = x.product
                                                 delete x.product
                                            }
                                            if(x.type == 'check_box' || x.type == 'radio_button' || x.type == 'drop_down'){
                                                 delete x['possible_values']
                                                 delete x.statement
                                            }
                                            if(x.add_attachments && x.hasOwnProperty('attachments')){
                                                 x.attachments.forEach((e) => {
                                                      delete e['created_time']
                                                      delete e['error']
                                                      delete e['progress']
                                                      // delete e['size']
                                                      delete e['uploading']
                                                 })
                                            }
                                            if(template.hasOwnProperty('attach_files')){
                                                 template.attach_files.forEach((y) => {
                                                      if(y.hasOwnProperty('created_time')){
                                                           delete y.created_time
                                                      }
                                                      if(y.hasOwnProperty('error')){
                                                           delete y.error
                                                      }
                                                      if(y.hasOwnProperty('progress')){
                                                           delete y.progress
                                                      }
                                                      if(y.hasOwnProperty('uploading')){
                                                           delete y.uploading
                                                      }
                                                 })
                                            }
                                            delete x['add_attachments']
                                            delete x['attachment_error']
                                            delete x['add_attachments']
                                            delete x['is_api_call_required']
                                            delete x['required']
                                            delete x['type']
                                            delete x['error']   
                                       })
                                       delete template.error
                                       delete template.show
                                  })
                                  try{
                                       this.editNewTicket(created_data)
                                  } catch(error) {
                                  }
                             }
                             else{
                                  this.$toasted.global.error("Please Fill All The Required Fields")
                             }
                        }
                        else if(this.attachments.length > 10){
                             this.$toasted.global.error("10 Attachments are Allowed")
                        }else{
                             this.$toasted.global.error("Please Fill All The Required Fields")
                        }
                   })
              },
              checkError(i) {
                   return i.error == false;
              },
              async editNewTicket(created_data) {
                   try{
                        // this.isUploadingInProgress = true
                        this.save_loader = true
                        let response = await this.editTemplateTicket(created_data)
                        if (response.status_id == 1){
                             this.success_msg = response.response
                             EventBus.$emit('RecallNotification')
                             this.$refs.success_modal.open();
                             setTimeout(() => {
                                  this.$refs.success_modal.close();
                                  this.save_loader =false
                                  EventBus.$emit('RecallNotification')
                                  this.$router.push({ path: "/ticketdetails", query: {'ticket': this.editTicketDetails, 'list': this.$route.query.list ,redirected_from: 'edit_ticket'} })
                             }, 3000);
                        } else if(response.status_id == 0){
                             this.warning_msg = response.reason
                             this.save_loader = false
                             this.$refs.warning_modal.open();
                             setTimeout(() => {
                                  this.$refs.warning_modal.close();
                             }, 3000);
                        }
                   } catch(err){
                        this.save_loader =false
                        this.warning_msg =err
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                             this.$refs.warning_modal.close();
                        }, 3000);
                   }  
              },
              checkTicketType(){
                   if(this.ticketType == null) {
                        this.editTicketTemplate = []
                   }
              },
              // Attachments and upload data
              inputFile(newFile, oldFile) {
                   this.temp_attachments = []
                   if (newFile && oldFile) {
                        if (newFile.active && !oldFile.active) {
                        if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
                             this.$refs.upload.update(newFile, { error: 'size' })
                        }
                        }
                        if (newFile.progress !== oldFile.progress) {
                        }
                        if (newFile.error && !oldFile.error) {
                        }
                        if (newFile.success && !oldFile.success) {
                        }
                   }
                   if (!newFile && oldFile) {
                        if (oldFile.success && oldFile.response.id) {
                        }
                   }
                   if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                        if (this.uploadAuto && !this.$refs.upload.active) {
                        this.$refs.upload.active = true
                        }
                   }
                   this.input_file = newFile
                   this.uploadAttachment()
              },
              uploadAttachment(newFile,oldFile) {
                   let contains_duplicates = false
                   this.attachments.forEach((e) => {
                        if(e.name == newFile.file.name){
                             contains_duplicates = true
                        }
                   })
                   if(this.attachments.length < 10 && !contains_duplicates){
                        var input = newFile;
                        this.total_file_size = this.total_file_size + input.file.size
                        if (input.file) {
                             const CancelToken = axios.CancelToken;
                             const source = CancelToken.source();
                             let attachment = {
                                  name: input.file.name,
                                  size: JSON.stringify(input.file.size),
                                  source: source,
                                  progress: 0,
                                  created_time: new Date(),
                                  error: ""
                             }
                             this.attachments.push(attachment);
                             this.getResumable(input.file, this.attachments[this.attachments.length - 1]);
                        }    
                   } else if(contains_duplicates){
                        this.$toasted.global.error("This file is already uploaded")
                   } else {
                        this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                   }
              },
              dataAttachment(newFile, oldFile,val) {
                   var input = newFile;
                   this.total_file_size = this.total_file_size + input.file.size
                   if (input.file) {
                        const CancelToken = axios.CancelToken;
                        const source = CancelToken.source();
                        let attachment = {
                             name: input.file.name,
                             size: JSON.stringify(input.file.size),
                             source: source,
                             progress: 0,
                             created_time: new Date(),
                             error: ""
                        }
                        if (this.total_file_size > this.size){
                             this.$toasted.global.error("Attachments Size Cannot Exceed 25mb")
                             this.total_file_size = this.total_file_size - input.file.size
                        } else {
                             this.attachments.push(attachment);
                             this.getResumable(input.file, this.attachments[this.attachments.length - 1]);
                        }
                   }
              },
              getResumable(file, attachment) {
                   this.isUploadingInProgress = true;
                   attachment.uploading = true;
                   let data = {
                        file: attachment.name
                   }
                   data = new FormData()
                   data.append('file', file)
                   this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data, {
                        onUploadProgress: function (progressEvent) {
                             let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent
                             .total));
                             if (progress < 100) {
                             attachment.progress = progress;
                             }
                        }.bind(this)
                   })
                   .then(response => {
                        let resumable_url = response.data.url;
                        attachment.url = resumable_url;
                        attachment.progress = 100;
                        attachment.uploading = false;
                        this.isUploadingInProgress = false;
                        delete attachment['source'];
                        setTimeout(() => {
                             // this.saveFiles();
                        }, 500);
                   })
                   .catch(error => {
                        // console.log(error.data.reason)
                   })
              },
              deleteAttachment(attachment,index){
                   this.attachments.forEach((el,elindex)=>{
                        if(el.url == attachment.url){
                             this.attachments.splice(elindex,1)
                        }
                   })
              },
              async getCameraSelection() {
                   const devices = await navigator.mediaDevices.enumerateDevices();
                   const videoDevices = devices.filter(device => device.kind === 'videoinput');
                   this.camera_selection = videoDevices;
                   this.selected_camera_device = videoDevices[0].deviceId;
              },
              openCaptureImage() {
                   if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
                        this.show_capture_image = true;
                        setTimeout(() => {
                             this.$modal.show('capture-image');
                             this.getCameraSelection()
                             this.toggleCamera();
                        }, 500);
                   }
                   else {
                        this.warning_msg = "Camera capture device not found";
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                             this.$refs.warning_modal.close();
                        }, 3000);
                   }

              },
              openCaptureImageMulti(field_index) {
                   if(this.editTicketTemplate[field_index].attach_files.length < 10){
                        if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
                             this.show_capture_image_multi = true;
                             setTimeout(() => {
                             this.$modal.show(`capture-image${field_index}`);
                             this.getCameraSelection()
                             this.toggleCameraMultiPart(field_index);
                             }, 500);
                        }
                        else {
                             this.warning_msg = "Camera capture device not found";
                             this.$refs.warning_modal.open();
                             setTimeout(() => {
                             this.$refs.warning_modal.close();
                             }, 3000);
                        }
                   } else {
                        this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                   }
              },
              toggleCamera() {
                   if(this.isCameraOpen) {
                        this.isCameraOpen = false;
                        this.isPhotoTaken = false;
                        this.isShotPhoto = false;
                        this.stopCameraStream();
                   } else {
                        this.isCameraOpen = true;
                        this.createCameraElement();
                   }
              },
              toggleCameraMultiPart(field_index) {
                   if(this.isCameraOpen) {
                        this.stopCameraStreamMultiPart(field_index);
                        this.isCameraOpen = false;
                        this.isPhotoTaken = false;
                        this.isShotPhoto = false;
                   } else {
                        this.isCameraOpen = true;
                        this.createCameraElementMultiPart(field_index);
                   }
              },
              createCameraElement() {
                   this.isLoading = true;
                   const constraints = (window.constraints = {
                        audio: false,
                        video: true
                   });

                   navigator.mediaDevices
                        .getUserMedia(constraints)
                        .then(stream => {
                        this.isLoading = false;
                        this.$refs.camera_capture.srcObject = stream;
                   })
                   .catch(error => {
                        this.isLoading = false;
                        this.show_capture_image = false;
                        setTimeout(() => {
                             this.$modal.hide('capture-image');
                        }, 500);
                        alert("Please allow the camera access or your browser may not support it.");
                   });
              },
              createCameraElementMultiPart(field_index) {
                   this.isLoading = true;
                   const constraints = (window.constraints = {
                        audio: false,
                        video: true
                   });
                   navigator.mediaDevices
                        .getUserMedia(constraints)
                        .then(stream => {
                        this.isLoading = false;
                        this.$refs.camera_capture[field_index].srcObject = stream;
                   })
                   .catch(error => {
                        this.isLoading = false;
                        this.show_capture_image_multi = false;
                        setTimeout(() => {
                             this.$modal.hide(`capture-image${field_index}`);
                        }, 500);
                        alert("Please allow the camera access or your browser may not support it.");
                   });
              },
              stopCameraStream() {
                   let tracks = this.$refs.camera_capture.srcObject.getTracks();
                   tracks.forEach(track => {
                        track.stop();
                   });
                   this.show_capture_image = false;
                   setTimeout(() => {
                        this.$modal.hide('capture-image');
                        // this.stopCameraStream();
                   }, 500);
              },
              stopCameraStreamMultiPart(field_index) {
                   let tracks = this.$refs.camera_capture[field_index].srcObject.getTracks();
                   tracks.forEach(track => {
                        track.stop();
                   });
                   this.show_capture_image_multi = false;
                   setTimeout(() => {
                        this.$modal.hide(`capture-image${field_index}`);
                        this.stopCameraStreamMultiPart(field_index);
                   }, 500);
              },
              takePhoto() {
                   if(!this.isPhotoTaken) {
                        this.isShotPhoto = true;
                        const FLASH_TIMEOUT = 50;
                        setTimeout(() => {
                        this.isShotPhoto = false;
                        }, FLASH_TIMEOUT);
                   }
                   this.isPhotoTaken = !this.isPhotoTaken;
                   const context = this.$refs.canvas.getContext('2d');
                   context.drawImage(this.$refs.camera_capture, 0, 0, 250, 250);
              },
              takePhotoMultiPart(field_index) {
                   if(!this.isPhotoTaken) {
                        this.isShotPhoto = true;
                        const FLASH_TIMEOUT = 50;
                        setTimeout(() => {
                        this.isShotPhoto = false;
                        }, FLASH_TIMEOUT);
                   }
                   this.isPhotoTaken = !this.isPhotoTaken;
                   const context = this.$refs.canvas[field_index].getContext('2d');
                   context.drawImage(this.$refs.camera_capture[field_index], 0, 0, 250, 250);
              },
              blobToFile(theBlob, fileName){
                   //A Blob() is almost a File() - it's just missing the two properties below which we will add
                   theBlob.lastModifiedDate = new Date();
                   theBlob.name = fileName;
                   const myFile = new File([theBlob], 'captured_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png', {
                        type: theBlob.type,
                   });
                   return myFile;
              },
              uploadAttachmentFromCamera(file_data){
                   if(this.attachments.length < 10){
                        if (file_data) {
                             const CancelToken = axios.CancelToken;
                             const source = CancelToken.source();
                             let attachment = {
                                  name: file_data.name,
                                  size: JSON.stringify(file_data.size),
                                  source: source,
                                  progress: 0,
                                  created_time: new Date(),
                                  error: ""
                             }
                             this.attachments.push(attachment)
                             this.getResumableURL(file_data, this.attachments[this.attachments.length - 1]);
                        }
                   } else if(this.attachments.some((x) => x.name == file_data.name)){
                        this.$toasted.global.error("This file is already uploaded")
                   }  else {
                        this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                   }
              },
              uploadAttachmentFromCameraByPart(file_data, index){
                   if(this.editTicketTemplate[index].attach_files.length < 10){
                        if (file_data) {
                             const CancelToken = axios.CancelToken;
                             const source = CancelToken.source();
                             let attachment = {
                                  name: file_data.name,
                                  size: JSON.stringify(file_data.size),
                                  source: source,
                                  progress: 0,
                                  created_time: new Date(),
                                  error: ""
                             }
                             this.editTicketTemplate[index].attach_files.push(attachment)
                             this.getResumableURLByPart(file_data, this.editTicketTemplate[index].attach_files[this.editTicketTemplate[index].attach_files.length - 1]);
                        }
                   } else if(this.editTicketTemplate[index].attach_files.some((x) => x.name == file_data.name)){
                        this.$toasted.global.error("This file is already uploaded")
                   }  else {
                        this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                   }
              },
              async downloadImage() {
                   const canvas = document.getElementById("photoTaken").toDataURL("image/png")
                   const base64 = await fetch(canvas);
                   const blob = await base64.blob();
                   let fill = this.blobToFile(blob, 'captured_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
                   this.uploadAttachmentFromCamera(fill);
                   this.show_capture_image = false;
                   setTimeout(() => {
                        this.$modal.hide('capture-image');
                        this.toggleCamera()
                        this.stopCameraStream();
                   }, 500);
              },
              async downloadImageByPart(index){
                   const canvas = document.getElementById('photoTaken').toDataURL("image/png")
                   const base64 = await fetch(canvas);
                   const blob = await base64.blob();
                   let fill = this.blobToFile(blob, 'captured_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
                   this.uploadAttachmentFromCameraByPart(fill, index);
                   this.show_capture_image_multi = false;
                   this.$modal.hide(`capture-image${index}`);
                   this.toggleCameraMultiPart(index)
                   this.stopCameraStreamMultiPart(index);
              },
              dropDefaultAttachment(evt) {
                   // Prevent default behavior (Prevent file from being opened)
                   evt.preventDefault();
                   // Use DataTransfer interface to access the file(s)
                   [...evt.dataTransfer.files].forEach((file, i) => {
                        this.uploadDefaultFromDrop(file)
                   });
              },
              uploadDefaultFromDrop(event){
                   let contains_duplicates = false
                   this.attachments.forEach((e) => {
                        if(e.name == event.name){
                             contains_duplicates = true
                        }
                   })
                   if(this.attachments.length < 10 && !contains_duplicates){
                        if(event) {
                             var input = event;
                        }
                        if (input && event) {
                             const CancelToken = axios.CancelToken;
                             const source = CancelToken.source();
                             let attachment = {
                                  name: input.name,
                                  size: JSON.stringify(input.size),
                                  source: source,
                                  progress: 0,
                                  created_time: new Date(),
                                  error: ""
                             }
                             this.attachments.push(attachment);
                             this.getResumable(input.file, this.attachments[this.attachments.length - 1]);
                        } 
                   } else if(contains_duplicates){
                        this.$toasted.global.error("This file is already uploaded")
                   } else {
                        this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                   }    
              },
              dragOverAttachment(evt) {
                   // Prevent default behavior (Prevent file from being opened)
                   evt.preventDefault();
              },
              dropAttachment(evt, index) {
                   // Prevent default behavior (Prevent file from being opened)
                   evt.preventDefault();
                   // Use DataTransfer interface to access the file(s)
                   [...evt.dataTransfer.files].forEach((file, i) => {
                        this.uploadFromDrop(file, index)
                   });
              },
              uploadFromDrop(event, index) {
                   let contains_duplicates = false
                   this.editTicketTemplate[index].attach_files.forEach((e) => {
                        if(e.name == event.name){
                             contains_duplicates = true
                        }
                   })
                   if(this.editTicketTemplate[index].attach_files.length < 10 && !contains_duplicates){
                        if(event) {
                             var input = event;
                        }
                        if (input && event) {
                             const CancelToken = axios.CancelToken;
                             const source = CancelToken.source();
                             let attachment = {
                                  //id: uuidv4(),
                                  name: input.name,
                                  size: JSON.stringify(input.size),
                                  source: source,
                                  progress: 0,
                                  created_time: new Date(),
                                  error: ""
                             }
                             if(this.editTicketTemplate[index].attach_files.length < 10){
                                  this.editTicketTemplate[index].attach_files.push(attachment)
                                  this.getResumableURLByPart(input, this.editTicketTemplate[index].attach_files[this.editTicketTemplate[index].attach_files.length - 1]);
                             } else {
                                  this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                             }
                        }
                   } else if(contains_duplicates){
                        this.$toasted.global.error("This file is already uploaded")
                   } else {
                        this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                   }
              },
              uploadAttachmentByPart(event, index){
                   if(this.editTicketTemplate[index].attach_files.length < 10){
                        if(event) {
                             var input = event.target;
                        }
                        if(event == undefined) {
                             var input 
                             input = this.$refs.upload.files
                             let contains_duplicates = false
                             this.editTicketTemplate[index].attach_files.forEach((e) => {
                                  if(e.name == input[0].file.name){
                                       contains_duplicates = true
                                  }
                             })
                             if(this.editTicketTemplate[index].attach_files.length < 10 && !contains_duplicates){
                                  input['files'] = []
                                  input.files.push({
                                  lastModified : input[0].file.lastModified,
                                  name : input[0].file.name,
                                  size : input[0].file.size,
                                  type : input[0].file.type,
                                  webkitRelativePath : input[0].file.webkitRelativePath,
                                  lastModifiedDate : input[0].file.lastModifiedDate
                                  })
                                  const CancelToken = axios.CancelToken;
                                  const source = CancelToken.source();
                                  let attachment = {
                                  name: input.files[0].name,
                                  size: JSON.stringify(input.files[0].size),
                                  source: source,
                                  progress: 0,
                                  created_time: new Date(),
                                  error: "",
                                  url:""
                                  }
                                  this.editTicketTemplate[index].attach_files.push(attachment)
                                  this.getResumableURLByPart(input[0].file, this.editTicketTemplate[index].attach_files[this.editTicketTemplate[index].attach_files.length - 1]);
                             } else if(contains_duplicates){
                                  this.$toasted.global.error("This file is already uploaded")
                             } else {
                                  this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                             }
                        }
                        if (input.files && input.files[0] && event) {
                             let contains_duplicates = false
                             this.editTicketTemplate[index].attach_files.forEach((e) => {
                                  if(e.name == input.files[0].name){
                                       contains_duplicates = true
                                  }
                             })
                             if(this.editTicketTemplate[index].attach_files.length < 10 && !contains_duplicates){
                                  const CancelToken = axios.CancelToken;
                                  const source = CancelToken.source();
                                  let attachment = {
                                       name: input.files[0].name,
                                       size: JSON.stringify(input.files[0].size),
                                       source: source,
                                       progress: 0,
                                       created_time: new Date(),
                                       error: ""
                                  }
                                  this.editTicketTemplate[index].attach_files.push(attachment)
                                  this.getResumableURLByPart(input.files[0], this.editTicketTemplate[index].attach_files[this.editTicketTemplate[index].attach_files.length - 1]);
                             } else if(contains_duplicates){
                                  this.$toasted.global.error("This file is already uploaded")
                             } else {
                                  this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                             }
                        }
                   } 
              },
              getResumableURLByPart(file, attachment) {
                   this.isUploadingInProgress = true;
                   let usage_type = {
                        usage: "attachment"
                   } 
                   let data = {
                        file: attachment.name
                   }
                   data = new FormData()
                   data.append('file',file)
                   Object.keys(usage_type).map(e => {
                        data.append(e, JSON.stringify(usage_type[e]))
                   })
                   this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data,{
                        onUploadProgress: function (progressEvent) {
                             let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                             if (progress < 100) {
                             attachment.progress = progress;
                             }
                        }.bind(this)
                   })
                   .then(response => {
                        let resumable_url = response.data.url;
                        attachment.url = resumable_url;
                        attachment.progress = 100;
                        attachment.uploading = false;
                        this.isUploadingInProgress = false;
                        delete attachment['source'];
                        if (response.data.hasOwnProperty('reason')){
                             attachment.error = "Error Uploading"
                             if (attachment.url == undefined) {
                             this.check_attachments = true
                             } else {
                             this.check_attachments = false
                             }
                        }
                   })
                   .catch(error => {
                   })
              },
              deleteAttachmentByPart(attachment,part_index){
                   this.editTicketTemplate[part_index].attach_files.forEach((el,elindex)=>{
                        if(el.url == attachment.url){
                             this.editTicketTemplate[part_index].attach_files.splice(elindex,1)
                        }
                   })
                   this.$forceUpdate()
              },
              deleteMPFieldAttachment(part_index, field_index, attachment_index){
                   this.editTicketTemplate[part_index].parts_data[field_index].attachments.splice(attachment_index, 1)
                   this.$forceUpdate()
              },
              deleteDefaultFieldAttachment(index, attachment_index){
                   this.editTicketTemplate[index].attachments.splice(attachment_index, 1)
                   this.$forceUpdate()
              },
              uploadMPFieldAttachment(event, part_index, field_index){
                   let contains_duplicates = false
                   this.editTicketTemplate[part_index].parts_data[field_index].attachments.forEach((e) => {
                        if(e.name == event.name){
                             contains_duplicates = true
                        }
                   })
                   if(!contains_duplicates){
                        if(event) {
                             var input = event.target;
                        }
                        if (input.files && input.files[0] && event) {
                             const CancelToken = axios.CancelToken;
                             const source = CancelToken.source();
                             let attachment = {
                                  name: input.files[0].name,
                                  size: JSON.stringify(input.files[0].size),
                                  source: source,
                                  progress: 0,
                                  created_time: new Date(),
                                  error: ""
                             }
                             this.editTicketTemplate[part_index].parts_data[field_index].attachments.push(attachment)
                             this.editTicketTemplate[part_index].parts_data[field_index].attachment_error = false 
                             this.getResumableURLFieldAttachment(input.files[0], this.editTicketTemplate[part_index].parts_data[field_index].attachments[this.editTicketTemplate[part_index].parts_data[field_index].attachments.length - 1]);
                        }
                   } else {
                        this.$toasted.global.error("This file is already uploaded")
                   }
              },
              dropAttachmentDefaultFieldAttachment(evt, field_index) {
                   evt.preventDefault();
                   if(this.editTicketTemplate[field_index].attachments.length + [...evt.dataTransfer.files].length <= 5){
                        [...evt.dataTransfer.files].forEach((file, i) => {
                             this.uploadFromDropDefaultFieldAttachment(file, field_index)
                        });
                   } else {
                        this.$toasted.global.error("Attachments limit should not exceed more than 5")
                   }
              },
              dropAttachmentMPFieldAttachment(evt, part_index, field_index) {
                   evt.preventDefault();
                   if(this.editTicketTemplate[part_index].parts_data[field_index].attachments.length + [...evt.dataTransfer.files].length <= 5){
                        [...evt.dataTransfer.files].forEach((file, i) => {
                             this.uploadFromDropMPFieldAttachment(file, part_index, field_index)
                        });
                   } else {
                        this.$toasted.global.error("Attachments limit should not exceed more than 5")
                   }
              },
              uploadFromDropMPFieldAttachment(event, part_index, field_index) {
                   let contains_duplicates = false
                   this.editTicketTemplate[part_index].parts_data[field_index].attachments.forEach((e) => {
                        if(e.name == event.name){
                             contains_duplicates = true
                        }
                   })
                   if(!contains_duplicates){
                        if(event) {
                             var input = event;
                        }
                        if (input && event) {
                             const CancelToken = axios.CancelToken;
                             const source = CancelToken.source();
                             let attachment = {
                                  name: input.name,
                                  size: JSON.stringify(input.size),
                                  source: source,
                                  progress: 0,
                                  created_time: new Date(),
                                  error: ""
                             }
                             this.editTicketTemplate[part_index].parts_data[field_index].attachments.push(attachment)
                             this.getResumableURLFieldAttachment(input, this.editTicketTemplate[part_index].parts_data[field_index].attachments[this.editTicketTemplate[part_index].parts_data[field_index].attachments.length - 1]);
                        }
                   } else {
                        this.$toasted.global.error("This file is already uploaded")
                   }
              },
              uploadFromDropDefaultFieldAttachment(event, field_index) {
                   let contains_duplicates = false
                   this.editTicketTemplate[field_index].attachments.forEach((e) => {
                        if(e.name == event.name){
                             contains_duplicates = true
                        }
                   })
                   if(!contains_duplicates){
                        if(event) {
                             var input = event;
                        }
                        if (input && event) {
                             const CancelToken = axios.CancelToken;
                             const source = CancelToken.source();
                             let attachment = {
                                  name: input.name,
                                  size: JSON.stringify(input.size),
                                  source: source,
                                  progress: 0,
                                  created_time: new Date(),
                                  error: ""
                             }
                             this.editTicketTemplate[field_index].attachments.push(attachment)
                             this.getResumableURLFieldAttachment(input, this.editTicketTemplate[field_index].attachments[this.editTicketTemplate[field_index].attachments.length - 1]);
                        }
                   } else {
                        this.$toasted.global.error("This file is already uploaded")
                   }
              },
              uploadDefaultFieldAttachment(event, index){
               console.log(event)
                   if(event) {
                        var input = event.target;
                   }
                   let contains_duplicates = false
                   this.editTicketTemplate[index].attachments.forEach((e) => {
                        if(e.name == input.files[0].name){
                             contains_duplicates = true
                        }
                   })
                   if(!contains_duplicates){
                        if (input.files && input.files[0] && event) {
                             const CancelToken = axios.CancelToken;
                             const source = CancelToken.source();
                             let attachment = {
                                  name: input.files[0].name,
                                  size: JSON.stringify(input.files[0].size),
                                  source: source,
                                  progress: 0,
                                  created_time: new Date(),
                                  error: ""
                             }
                             this.editTicketTemplate[index].attachments.push(attachment)
                             this.editTicketTemplate[index].attachment_error = false 
                             this.getResumableURLFieldAttachment(input.files[0], this.editTicketTemplate[index].attachments[this.editTicketTemplate[index].attachments.length - 1]);
                        }
                   } else {
                        this.$toasted.global.error("This file is already uploaded")
                   }
              },
              getResumableURLFieldAttachment(file, attachment) {
                   this.isUploadingInProgress = true;
                   attachment.uploading = true;
                   let usage_type = {
                        usage: "attachment"
                   }
                   let data = {
                        file: attachment.name
                   }
                   data = new FormData()
                   data.append('file',file)
                   Object.keys(usage_type).map(e => {
                        data.append(e, JSON.stringify(usage_type[e]))
                   })
                   this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data,{
                        onUploadProgress: function (progressEvent) {
                             let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                             if (progress < 100) {
                             attachment.progress = progress;
                             }
                        }.bind(this)
                   })
                   .then(response => {
                        let resumable_url = response.data.url;
                        attachment.url = resumable_url;
                        attachment.progress = 100;
                        attachment.uploading = false;
                        this.isUploadingInProgress = false;
                        delete attachment['source'];
                        this.$forceUpdate()
                   })
                   .catch(error => {
                        console.log(error.data.reason)
                   })
              },
         },
         mounted(){
              EventBus.$on('UpdateAppRejView', () => {
                   this.getDetails()
              })
         },
         computed:{
              loggedInUser() {
                   return this.$store.state.store.loggedInUser
              },
              create_json(){
                   return{
                        assignment_details: {
                             id:this.assignedCustomer.id || '',
                             is_assigned: this.assignedTo == 'unassigned' ? false : true,
                             to: this.assignedTo
                        },
                        // attach_files: this.attachments,
                        description: this.description,
                        subject: this.subject,
                        template_data: this.editTicketTemplate,
                        ticket_id: this.$route.params.id
                   }
              }
         },
         watch: {
              '$route.path': function(params){
                   this.getDetails();
              },
         },
         created(){
              this.getDetails();
              this.searchTemplateApiDD = debounce(this.searchTemplateApiDDDebouncer, 250)
              this.searchApiDD = debounce(this.searchApiDDDebouncer, 250)
              this.getAllAssignTo = debounce(this.getAllAssignToDebouncer, 250)
         }
    })
</script>

<style scoped>
    .activeDetails{
        background-color: #00448f !important;
        color: #fff !important;
        width: 200px !important;
        border-radius: 14px !important;
        height: 40px !important;
        font-weight: 500 !important;
        text-transform: none;
        font-size: 16px !important;
    }
    .boxHeader{
        background: #005dae;
        color: #fff;
        padding: 5px 25px;
        font-weight: 500;
        font-size: 14px;
    }
    .boxShadow{
        box-shadow: 0px 0.5px 7px 2px rgba(0, 0, 0, 0.16);
        background-color: #ffffff;
        border-radius: 8px;
    }
    .vendor_type span{
        margin-left: 10px;
        font-size: 14px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #000000;
    }
    .btn-blue{
        background: #005dae;
        color: #fff;
    }
    .ticket_decription{
        border: 1px solid #707070;
        border-radius: 10px;
        margin-left: 10px;
    }
    .ticket_decription .quillWrapper .ql-toolbar.ql-snow .ql-formats:nth-child(8){
        display: none !important;
    }
    .decription{
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        padding: 8px 25px;
        font-size: 14px;
        font-weight: 600;
        border-bottom: 1px solid #303031;
    }
    .dlt_descs{
        float: right;
        position: relative;
        bottom: 30px;
        right: 10px;
    }
    .btn-upload {
        /* background: #00448b; */
        border-radius: 15px !important;
        text-transform: none !important;
        padding: 6px 18px !important;
        font-weight:500 !important;
    }
    .btn-upload-disabled{
        background: #e8e8e8 !important;
        border-radius: 15px !important;
        text-transform: none !important;
        padding: 6px 18px !important;
        font-weight:500 !important;
    }
    .attachment-bg-new{
        /* border: 1px solid #005dae !important; */
        background: transparent !important;
        width: 100%;
    }
    .file-bg{
        background-color: #f0f3f5;
        padding: 5px;
        border-radius: 2px;
    }
    ._wizardBox{
        background-color: #f4f9ff;
        border: #005dae;
        width: 50%;
        height: 100px;
        padding: 10px;
        position: relative;
        left: 25%;
    }
    #progressbar {
        margin-bottom: 10px;
        overflow: hidden;
        color: #303031;
        width: 100%;
        display: flex;
        margin: 0;
        padding: 0;
        align-items: center;
        justify-content: center;
    }
    
    #progressbar .active {
        color: #303031
    }
    
    #progressbar li {
        list-style-type: none;
        font-size: 12px;
        width: 33%;
        position: relative;
        text-align: center;
    }
    #progressbar li strong {
        display: block;
        opacity: 0.5;
    }
    
    #progressbar li strong.active {
        opacity: 1;
    }
    
    #progressbar li img {
        position: relative;
        z-index: 2;
    }
    #progressbar li:before {
        content: '';
        width: 100%;
        border-top: dashed 2px #cdcdcd;
        position: absolute;
        left: -50%;
        top: 27px;
        z-index: 1
    }
    #progressbar li:first-child::before{
        width: 0% !important;
    }
    #progressbar li.active:before {
        border-top: solid 2px #005dae;
    }
    .inputLabel {
        margin-left: 6px;
    }
    .jobHide{
        margin-top: 14px !important;
    }
    .page-layout.blank {
        overflow: inherit;
    }
    .desc-textarea {
        padding-top: 6px!important;
        width: 100%;
        background: transparent;
        color: #303031;
        /* border-radius: 5px; */
        border: none !important;
        border-bottom: 2px solid #0d84f2 !important;
        resize: none;
        padding: 10px;
        overflow-y: auto;
        padding-right: 75px!important;
        min-height: 140px;
    }
    .desc-editor{
        background: transparent;
        color: #303031;
        font-size: 14px !important;
        display: block;
        width: 100%;
        border-radius: 5px;
        border: solid 1px #3f3f3f!important;
        background: transparent !important;
        font-weight: 500;
        border-radius: 5px !important;
    }
    .bord-left .mx-input{
        border-top-left-radius: 8px !important;
        border-bottom-left-radius: 8px !important;
    }
    .diginewhelp-multiselect {
        font-weight: 600;
        color: #7B7F83 !important;
    }
    .gps-logo{
        border-radius: 5px;
        padding: 5px;
        border: 1px solid rgb(0, 0, 0);
        position: relative;
        top: -9px;
        margin-left: 5px;
    }
    .color-blue{
        color: #005dae;
    }
    .text-grey{
        color: #656565;
    }
    .filterSelectedName{
        position: relative;
        top:3px;
    }
    .filterSelectedName1{
        position: relative;
        top:0px;
    }
    .w-150{
        width: 150px !important;
    }
    .word-wrap{
        word-break: break-all !important;
        white-space: pre-wrap;
    }
    .h-100{
        height: 100% !important;
    }
    .dynamic-section{
        /* background-color: rgba(0, 0, 0, 0.05) !important; */
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
        border-radius: 6px !important;
    }
    /* .dynamic-section .table-content .table-content-data thead tr th{
        background-color: #0d84f2;

    }
    .dynamic-section .table-content .table-content-data tbody tr td{
        background-color: #cce3fc;

    } */
    .dynamic-section .table-content .table-content-data-custom tbody tr td{
        background-color: #fafafa;
    }
    .dynamic-section .table-content .table-content-data-custom thead tr th{
        background-color: rgba(19, 14, 14, 0.75);

    }
    .infoHeader>.descriptionheader .description-text-header-right img{
        width: 23px !important;
    }
    .approved-btn{
        background-color: #40ad5c;
    }
    .rejected-btn{
        background-color: #F44336 !important;
    }
    .approved-btn, .rejected-btn{
        width:92px !important;
        padding: 5px 10px;
        border-radius: 5px !important;
        color: #fff;
        text-align: center;
    }
    .filter-multiple .custom__tag {
        background: #81aee6;
        color: #fff;
        padding: 2px 8px !important;
        border-radius: 20px;
        margin-right: 5px !important;
        display: inline-block;
        margin-bottom: 5px !important;
    }
    
    .filter-multiple .custom__tag1 {
        background: #81aee6;
        color: #fff;
        padding: 4px 8px !important;
        border-radius: 20px;
        margin-right: 5px !important;
        display: inline-block;
        margin-bottom: 5px !important;
    }
    
    .filter-multiple .custom__tag .custom__remove i {
        position: relative;
        top: -3px;
        right: -3px;
    }
    .filter-multiple .custom__tag1 .custom__remove i {
        position: relative;
        top: 0px;
        right: -3px;
    }
    .bg-grey{
        background-color: rgba(0,0,0,0.06) !important;
    }
    .bg-white{
        background-color: white !important;
    }
    .inverse div{
         position: absolute;
         top: 27px;
         width: 11px;
         height: 11px;
         border-radius: 50%;
         background: #fff;
         animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .h-100{
        height: 100% !important;
    }
    .position-absolute{
         position: absolute !important;
    }
    .cursor-notallowed{
        cursor: not-allowed !important
    }
    .text-align-left{
        text-align: left;
    }
    .w-90{
        width: 90px !important;
    }
    .w-130{
        width: 130px !important
    }
    .w-140{
        width: 140px !important;
    }
    .text-grey{
        color: #abaaac;
    }
    .bg-grey-box{
        background: #f1f3f4
    }
    .dotted-grey{
        border: dotted 2px #89898d;
    }
    .no-att-msg{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        color: rgba(59, 77, 92, 0.16);
    }
    .browse-box{
        height: 200px;
    }
    .choose-file{
        border-radius: 5px !important;
    }
    .fs-15px{
        font-size: 15px !important
    }
    .mx-width-220{
        max-width: 285px !important;
    }
    @media screen and (max-width: 768px) {
        .p-med-12{
            padding-left: 12px !important;
            padding-right: 12px !important;
            padding-top: 12px;
        }
        .pl-med-12{
            padding-left: 12px !important;
        }
        .justify-center-frsm{
            justify-content: center;
        }
    }
    .paste-input::placeholder{
        font-weight: 400 !important;
    } 
    .breadcrumbnewtheme{
        display: flex;
        align-items: center;
        gap: 1rem;
    }
    .header-bottom{
        border-bottom: 2px solid #636e71;
    }
    .breadcrumbnewtheme div{
        color: #00448b;
    }
    .fs-2rem{
        font-size: 2rem;
    }
    .position-content-main{
        border-radius: 14px;
        background-color: #f0ddb7;
    }
    .header-color{
        color: #4e4e4e !important;
    }
    .color-light-blue{
        color: #0066d0;
    }
    .general-box{
        background: white;
        border-radius: 10px;
    }
    .min-height-500px{
         min-height: 500px;
    }
</style>